import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { Config } from 'src/app/config/constants';
import { BaseService } from 'src/app/core/services/base.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-account-mga',
  templateUrl: './account-mga.component.html',
  styleUrls: ['./account-mga.component.scss'],
  providers: [DatePipe]
})
export class AccountMgaComponent implements OnInit {
  url: string ="https://www.getreliable.com/getreliable/login.aspx"
  // url: string ="https://www.getreliable.com/getreliable/login.aspx?twa=al&citycode=TAITEST&initials=tech&password=123456"
  userNamechangeval:any;
  @BlockUI() blockUI: NgBlockUI;
  leadId: any;
  leadType: any;
  leadStatus: any;
  error = '';
  drop:boolean=false;
  noti:boolean=false;
  agentcodedata=[];
  transferagentcodedata=[];
  agentcodedata1=[];
  sub: any;
  isFirstTimeActivated: any;
  firstTimeActivatedCount:any;
  leadEmailInfo:any;
  firstName: any;
  lastName: any;
  provinceData=[];
  fileExtensionErrorMsg: boolean=false;
  showlicpErrorMsgone:  boolean=false;
  showlicdErrorMsgone:  boolean=false;
  showlictErrorMsgone:  boolean=false;
  showlicnErrorMsgone:  boolean=false;
  isButtonDisabled: boolean = false;
  havePendingEtransferTrans : Boolean=false;
  msgfinal: string;
  msg: string;
  productPhotofile: string | Blob;
  fileIdlic: any;
  licenceId: any;
  expiryDateLic1: any;
  filelicens: any;
  licenseNumber: any;
  licencesType: any;
  getAgencyCode: any;
  agencyCode:any;
  agencyCodeORIC:any;
  seleectedagencyCode:any;
  province: any;
  showemailErrorMsg: boolean;
  FileDataList: any;
  fileenoName: any;
  fileExtensionENO: any;
  fileExtensionErrorENO: boolean;
  fileExtensionMessageENO: string;
  eoexpiryDate1: string;
  fileeno: any;
  expiryDate: any;
  policyNumber: any;
  showdateErrorMsg: boolean;
  showdateErrorMsg1: boolean;
  documentId: any;
  fileId: any;
  agencyId: any;
  holidayhourPopup:boolean=false;
  uploadPaymentMudulePopup:boolean=false;
  uploadPaymentMudulePopupORIC:boolean=false;
  loading:boolean=false;
  agentCodeId: any;
  cardHolderName: any;
  dateTransfer: any;
  creditCardInfo: any;
  payAmount: any;
  totalOwingAmount: any;
  cardNoToSend: any;
  expDate1ToSend2: any;
  ccNum: any;
  expDate: any;
  paymentypeZurichOric: any;
  agencyCodePaymentModule: any;
  owingBalance: any;
  getBalance: any=[];
  getOricOwing: any=[];
  selectedAgencyCode:any=[];
  gelBal: any;
  cardType: any;
  cardNoValid: boolean=false;
  cardError: boolean=false;
  AmountError: boolean=false;
  actualAmount: any;
  BankNameOnCardErrMsg: boolean=false;
  BankExpDateErrMsg: boolean=false;
  BankAmountErrMsg: boolean=false;
  BankCreditCardErrMsg: boolean=false;
  BankAgencyOricErrMsg: boolean=false;
  creditCardPopup: boolean=false;
  etransferPopup: boolean =false;
  fromAnotherAgencyCode: boolean =false;
  agencyCodeBalance: any;
  paymentType: any ='CreditCard';
  agencyName: any;
  transferAgentCodeId: any;
  getAgentCodeForAgency: any;
  DatetransferErrMsg: boolean=false;
  getAgencyName: any;
  agencyNames: any;
  getAgencyBalance: any;
  payAmount1: any;
  planType: any;
  overridecode: any;
  getAgentCodeForAgencyORIC: any;
  getAgencyNameORIC: any;
  // showPopupEmail:boolean=false;
  showMobileResponsivePopup:boolean=false;
  callMgaAPI:boolean=false;
  documentType: any;
  mgaId: any;
  isOverWriteEO:boolean=false
  lastTrainingDate: string;
  isTraningExpired:boolean=false;
  nextSessionDate: string;
  brokerStatus: any;
  oricid: any;
  todayDate: Date;
  pricePopup:boolean=false;
  pricePopup1:boolean=false;
  effectiveDate: string;
  effectiveDate1: string | number | Date;
  showliceffectiveDateErrorMsgone:boolean=false
  effectiveDateLic1: string;
  overrideCode: any;
  uniqueIdOfOwing: any;
  brokerLinkMGA: any=[];
  residentProvinceData: any;
  PortalAnnouncement:boolean=false;
  PortalAnnouncement1:boolean=false;
  sinNo: any;
  sinNoErrMsg: boolean=false;
  confirmsinNo: any;
  confirmsinNoErrMsg: boolean=false;
  SINPopup: boolean=false;
  ConfirmationPopupAnnual: boolean=false;
  personalinfo: any;
  Salutation: any;
  salutation: any;
  wfgCode: any;
  languages: any=[];
  tags: any=[];
  PLicensedArray: any=[];
  allProvicesList: any;
  isBankingInfoAvailable: boolean=true;
  isSINInfoAvailable: boolean=true;
  emailAddress: any=[];
  salesContest: boolean=false;
  hideSalesContest: boolean=false;
  hideSalesContest1: boolean=false;
  requestedData: any;
  isDocumentRequested: boolean=false;
  hideLastRequestedDateSIN: boolean;
  lastRequestedDateSINBy: any;
  requestSINHistory: any;
  lastRequestedDateSIN: any;
  brokerLinkMGAAgency:any=[]
  checkStatusAnnualConfirmation: any;
  rememberMeChecked1: boolean = false;
  rememberMeChecked: boolean = false;
  relatedToName: string;
  action: any;
  optOutDays: null;
  name: string;
  relatedToId: any;
  checkUserIsCancelledannualConfirmationPopup: any;
  constructor(public user: UserService, private base: BaseService,private router: Router,public config: Config,private DatePipe:DatePipe) {
    this.todayDate = new Date();
   }
 
  ngOnInit(): void {
    this.name=sessionStorage.getItem("username");
    this.showMobileResponsivePopup=JSON.parse(sessionStorage.getItem("showMobileResponsivePopup"));
    this.dateTransfer = new Date();
    // this.showPopupEmail=JSON.parse(sessionStorage.getItem("showPopupEmail"));
    // if(this.showPopupEmail==true){
    //   this.emailpopup();
    // }
    // Swal.fire("","We are currently experiencing an error with our outgoing Confirmation of Coverage (COC) emails. We have identified the issue and are working on a solution. Our Support Services Team is monitoring International Student Travel Insurance (ISP) sales and will email the COC directly to the client(s). We apologize for the inconvenience.",'info');
    // const currentDate10 = new Date();
    //  
    //  console.log(currentDate10.getDate());
    // if(currentDate10.getDate() === 18){
      // this.holidayhourPopup=true;      
    //  this.holidayhourPopup=JSON.parse(localStorage.getItem('holidayhourPopup'));
    this.leadStatus=sessionStorage.getItem('leadStatus');
    // if (this.leadStatus!="Activated"){
    //   localStorage.setItem('PortalAnnouncement', JSON.stringify(true));
    // }
    // this.hideSalesContest1 = JSON.parse(localStorage.getItem('PortalAnnouncement'));
    // if (this.hideSalesContest1 == false) {
    //   this.hideSalesContest = true
    // }
    // else {
    //   this.hideSalesContest = false
    // }
    //  this.pricePopup1=JSON.parse(localStorage.getItem('pricePopup'));
    //  if(this.pricePopup1==false){
    //   this.pricePopup=true
    //  }
    //  else{
      this.pricePopup=false
    //  }
    // }
    // else{
    //   this.holidayhourPopup=false;
    // localStorage.setItem('holidayhourPopup',JSON.stringify(false));
    // }    
    localStorage.setItem('docViewEnable','false');
    this.leadId=sessionStorage.getItem('leadId');
    this.requestedSINHistory(this.leadId)
    this.agencyId=sessionStorage.getItem("agencyId")
    this.mgaId=sessionStorage.getItem("mgaId")
    //debugger
    sessionStorage.setItem('MgaIddropdown',this.mgaId);
    this.leadType=sessionStorage.getItem('leadtype');
    if(this.leadType=="Office Admin Staff")
    {
      // this.router.navigateByUrl('/dashboard/dashboard-mga');
      this.router.navigate(['/dashboard/dashboard-mga']);
    } 
     this.leadStatus=sessionStorage.getItem('leadStatus');
     this.leadEmailInfo= JSON.parse(sessionStorage.getItem('leadEmailInfo')) ;
     sessionStorage.removeItem('agencyCodeSalesPortal');
     sessionStorage.removeItem('agentIdSalesPortal');
     sessionStorage.removeItem('agentIdS');
     localStorage.removeItem('searchCriteria');
    // this.leadStatus="Activated";
    // if(this.agencyId!=null){
    //   this.getAgencyDocuments(this.agencyId,this.leadId)
    // }
    debugger
    this.checkUserIsCancelledannualConfirmationPopup = sessionStorage.getItem("checkUserIsCancelledannualConfirmationPopup");

    // Check for null or "false" (string), and then call the API
      if (this.checkUserIsCancelledannualConfirmationPopup === null ||this.checkUserIsCancelledannualConfirmationPopup === "false") {
        this.annualConfirmationPopup();
      }
        this.getLeadAgentsCodes();
        this.getTransferAgentCodes();
        
        this.getDashboard();
        this.getLicensRequest();
        this.getEORequest();
        this.getVoidChequeRequest();  
        this.getPaymentModuleDetails();
        this.getLastTrainingDate();
        this.getMiscDocument();
        this.getMgaOVRBalanceOwing();
  }


  emailpopup(){
    Swal.fire({
      // title: 'Are you sure?',
      text: "We are currently experiencing an error with our outgoing Confirmation of Coverage (COC) emails. We have identified the issue and are working on a solution. Our Support Services Team is monitoring International Student Travel Insurance (ISP) sales and will email the COC directly to the client(s). We apologize for the inconvenience.",
      icon: 'info',
      // showCancelButton: true,
      confirmButtonColor: '#3085d6',
     
      confirmButtonText: 'ok'
    }).then((result) => {
      if (result.isConfirmed) {
        this.showMobileResponsivePopup=false
        sessionStorage.setItem("showMobileResponsivePopup",JSON.stringify(false))
      }
    })
  }

  getDocumentsAgency=[];
  getLicencesAgency=[];
  getVoidChequeAgency=[];
  getAgencyDocuments(agencyId,leadId){
    // debugger
    //this.agencyDocApiError=true;
    this.getDocumentsAgency=[];
    this.getLicencesAgency=[];
    this.getVoidChequeAgency=[];
    
    if(this.agencyId!=undefined){
      for(let i=0; i<this.brokerLinkMGAAgency.length;i++){
        if(this.brokerLinkMGAAgency[i].isCompnaySignUp){

       agencyId=this.brokerLinkMGAAgency[i].agencyId
      
    this.user.getAgencydocuments(agencyId,leadId).pipe()
    .subscribe(
      data => {
        
        // this.licencesTypes = data.data.licencesTypes
        if(data.data.documents != null){
          this.getDocumentsAgency.push(data.data.documents); 
        }
        if(data.data.licences.length>0){
          data.data.licences.forEach((licence: any) => {
            this.getLicencesAgency.push(licence);
          });
        }
        if (this.leadType == 'Travel Agent') {
          this.getLicencesAgency = this.getLicencesAgency.filter(licence => {
              // Check the provinceCode for each licence and remove if it's not 'NS'
              return licence.provinces.provinceCode === 'NS';
          });
      }
        // if(data.data.accountDetails != null){
        //   this.getVoidChequeAgency.push(data.data.accountDetails);
        // }
        if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidChequeAgency.push(voidChequeaccountDetails);
          });
        }
 
      }, error => {
        //  if(this.baseservice.handleError(error)){
        //handle Exception from Server 404,401
      
      }, () => { });
    }
  }
}
  }
  
     
          
  

  link: any;
  authorizeUser(){
      //debugger
    const email=this.leadEmailInfo;
    if(email){
     // console.log(email)
       return this.user.authorizeUser(email).pipe()
    .subscribe(
        data => {
          if(data.status==true){
          this.link = data.data?.redirectPath;
           var win = window.open(this.link, '_blank');
            win.focus();
          }else{}
        },error=>{
         if(error.status == 400 || error.status==417){
               // this.error=error.error.data;
               }
            },()=>{});
    }
  }

  getLeadAgentsCodes(){
  this.user.getLeadAgentsCodes(this.leadId).pipe()
  .subscribe(
    data => {
      
    // console.log(data);
    this.agentcodedata=[];
  
    if(this.leadType=="Office Admin Staff" && data.data.agentCodes.length==0)
      {
        this.router.navigate(['/dashboard/dashboard-mga']);
      }
      else{      
    for(let i=0;i<data.data.agentCodes.length;i++){      
      if (data?.data?.agentCodes[i]?.agentUserId?.includes("_") || data?.data?.agentCodes[i]?.agentUserId?.includes("RL1")) {
        // If agentUserId contains underscore, do something
    } else {
        // If agentUserId does not contain underscore, push agentCodes[i] into agentcodedata
        this.agentcodedata.push(data.data.agentCodes[i]);
    }
    }
  }
    }, error => {

      if (error.status == 400 || error.status == 417) {
        this.error = error.error.data;
      }
      else {
        this.error = "Something went wrong. Please check username and password.";
      }
    }, () => { });
  }
  toggleadd(a,a1,agentCode,agentId,status) {
    //debugger
    sessionStorage.setItem('agentIdSalesPortal',agentCode);
    sessionStorage.setItem('agentIdS',agentId);
    sessionStorage.setItem('agencyCodeSalesPortal',a);
    if(status=="Active" || status=="Primary"){
      sessionStorage.setItem('agentIdActive','true');
    }
    else{
      sessionStorage.setItem('agentIdActive','false');
    }
    this.sub = a1;
     this.agentcodedata1=[]
     this.drop = false
    for(let i=0;i<this.agentcodedata.length;i++){
      if(this.agentcodedata[i].agentCode == a && this.agentcodedata[i].id==agentCode){
        this.agentcodedata1.push(this.agentcodedata[i]);
      }
    }
  this.drop = !this.drop;
   if (this.drop) {
     this.drop = true;
     this.noti = false;
   }
   else {
     this.drop = false;
   }
 }
 close1(){
  this.drop = !this.drop;
  // window.location.reload()
 }
 goToGetReliable(){
  var win = window.open(this.url, '_blank');
  win.focus();
}
addedFromSugar: boolean=false;
leadDeactivated: any;
mgaName:any;
getDashboard() {
  this.user.getDashboardData().pipe()
    .subscribe(
      data => {
        this.personalinfo = data.data.leads;
        this.salutation = data.data.leads.salutation;
        this.province = data.data.provinces
        this.wfgCode=this.personalinfo.wfgCode
        if (this.personalinfo.leadProvinces.length > 0) {
          for (let i = 0; i < this.personalinfo.leadProvinces.length; i++) {
            this.PLicensedArray.push({ "id": this.personalinfo?.leadProvinces[i]?.provinces?.id, "itemName": this.personalinfo?.leadProvinces[i]?.provinces?.provinceName +'-'+ this.personalinfo?.leadProvinces[i]?.provinces?.provinceCode });
          }
        }
        this.isFirstTimeActivated=data.data.leads.isFirstTimeActivated;
        this.firstTimeActivatedCount=data.data.leads.firstTimeActivatedCount;
        this.leadStatus=data.data.leads.leadStatus;
        this.firstName=data.data.leads.firstName;
        this.lastName=data.data.leads.lastName;
        this.leadType=data.data.leads.type;
        this.provinceData=data.data.provinces;
        this.residentProvinceData=data.data.leads.primaryAddressProvince;
        this.addedFromSugar=data.data.leads.addedFromSugar;
        this.leadDeactivated = data.data.leads.leadStatus;
        this.mgaName = data.data.leads.agencyMgaName;
        this.brokerStatus = data.data.leads.isTrainingEnable;
        // this.brokerLinkMGA = data.data.leads.brokerLinkMGAs;
        // debugger
     // this.brokerLinkMGA = data.data.leads.brokerLinkMGAs;
        const filteredItems = data.data.leads.brokerLinkMGAs.filter(item => item.isCompnaySignUp === true);

// Step 2: Remove duplicates within the filtered items based on agencyId
const uniqueFilteredItems = filteredItems.filter((item, index, self) => 
  item.agencyId !== null &&
  index === self.findIndex(i => i.agencyId === item.agencyId)
);

// Step 3: Remove items that already exist in brokerLinkMGAAgency (to avoid pushing duplicates)
const nonDuplicateItems = uniqueFilteredItems.filter(item =>
  !this.brokerLinkMGAAgency.some(existingItem => existingItem.agencyId === item.agencyId)
);

// Step 4: Push the non-duplicate items into brokerLinkMGAAgency
this.brokerLinkMGAAgency.push(...nonDuplicateItems);


data.data.leads.brokerLinkMGAs.forEach(item => {
    // Check if the mgaId already exists in this.brokerLinkMGA
    const exists = this.brokerLinkMGA.some(existingItem => existingItem.mgaId === item.mgaId);
  
    // If it doesn't exist, push it into this.brokerLinkMGA
    if (!exists) {
      this.brokerLinkMGA.push(item);
    }
  });
        this.getLeadDoc();
        if(this.agencyId!=null){
          this.getAgencyDocuments(this.agencyId,this.leadId)
        }
        if(this.mgaId!=null){
          this.getMGADocuments(this.mgaId,this.mgaIndex);
        }
        if(this.leadType=="Office Admin Staff")
        {
          
          // this.router.navigateByUrl('/dashboard/dashboard-mga');
          this.router.navigate(['/dashboard/dashboard-mga']);
        }
        if(this.leadType=="Broker" || this.leadType=="Broker-RIBO"){
          this.isBankingInfoAvailable = JSON.parse(localStorage.getItem('isBankingInfoAvailable'));
          this.isSINInfoAvailable = JSON.parse(localStorage.getItem('isSINInfoAvailable'));
        }
       }, error => {

        if (error.status == 400 || error.status == 417) {
          this.error = error.error.data;
        }
        else {
          this.error = "Something went wrong. Please check username and password.";
        }
  
      }, () => { });
}
uploadnewLicensePopup:boolean=false;
uploadEOPopup:boolean=false;
minDate = new Date();
  // onClickaddnewLicUpload(){
  //   this.uploadnewLicensePopup=false;
  //   Swal.fire("", "License successfully summited", 'success')
  // }
  getDocuments=[];
  getLicences=[];
  getVoidCheck=[];
  licencesTypes:[]
  corporateLicType=[];
  MgaLicType=[];
  individualLicType=[];
  showLicTypeonPopup=[];
 
  getLeadDoc() {
      
    this.getDocuments=[];
      this.getLicences=[];
      this.getVoidCheck=[];
          // this.user.getDocumentDetailsLead(this.leadId).pipe()
    this.user.getdocuments().pipe()

      .subscribe(
        data => {
          this.corporateLicType=[];
          this.MgaLicType=[];
          this.individualLicType=[];
          this.showLicTypeonPopup=[];
          this.licencesTypes = data.data.licencesTypes;
          for(let i=0; i<data.data.licencesTypes.length; i++){
            
            var testOVr = data.data.licencesTypes[i].toLowerCase();
            if (testOVr.slice(-2)=='dr' || testOVr.indexOf('corporate') > -1){
              if(data.data.licencesTypes[i]!=="General 3 - DR"){
              this.corporateLicType.push(data.data.licencesTypes[i])
              this.MgaLicType.push(data.data.licencesTypes[i])
            } 
            } 
            if(testOVr.indexOf('corporate') > -1){
              
            }
            else{
              this.individualLicType.push(data.data.licencesTypes[i])
            }
          }
          if(data.data.documents != null){
            this.getDocuments.push(data.data.documents); 
          }
          if(data.data.licences != null){
            this.getLicences = data.data.licences;
          }
          if (this.leadType == 'Travel Agent') {
            this.getLicences = this.getLicences.filter(licence => {
                // Check the provinceCode for each licence and remove if it's not 'NS'
                return licence.provinces.provinceCode === 'NS';
            });
        }
          // if(data.data.accountDetails != null){
          //   this.getVoidCheck = data.data.accountDetails;
          // }
           if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidCheck.push(voidChequeaccountDetails);
          });
        }
          // if (data.data.licences.length != 0) {
          //   for (var i = 0; i < data.data.licences.length; i++) {
          //     var obj = {}
          //     //this.uploadlicenseArray.push(data.data.licences[i]);
          //     obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();
          //     obj["createdAt"] = data.data.licences[i].createdAt;
          //     obj["createdBy"] = data.data.licences[i].createdBy;
          //     obj["description"] = data.data.licences[i].description;
          //     obj["expiryDate"] = data.data.licences[i].expiryDate;
          //     obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
          //     obj["fileId"] = data.data.licences[i].fileId;
          //     obj["fileUrl"] = data.data.licences[i].fileUrl;
          //     obj["id"] = data.data.licences[i].id;
          //     obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
          //     obj["licencesProvince"] = data.data.licences[i].licencesProvince;
          //     obj["licencesType"] = data.data.licences[i].licencesType;
          //     obj["licenseName"] = data.data.licences[i].licenseName;
          //     obj["licensesNumber"] = data.data.licences[i].licensesNumber;
          //     obj["status"] = data.data.licences[i].status;
          //     obj["type"] = data.data.licences[i].type;
          //     obj["updatedAt"] = data.data.licences[i].updatedAt;
          //     obj["provinceName"] = data.data.licences[i].provinces.provinceName;
          //     obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
                 
          //     this.uploadlicenseArray.push(obj)
          //   }
            
          // }
          // // else {
          // //   this.addFieldValue();
          // // }
          // if(data.data.accountDetails != null){
          //   this.getVoidCheck = data.data.accountDetails;
          // }
          // if (data.data.accountDetails.length != 0) {
          //   for (var i = 0; i < data.data.accountDetails.length; i++) {
          //     var obj = {}
          //     // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
          //     obj["urltreamvoid"] = data.data.accountDetails[i].fileDownloadUrl.split('.').pop();
          //     obj["createdAt"] = data.data.accountDetails[i].createdAt;
          //     obj["createdBy"] = data.data.accountDetails[i].createdBy;
          //     obj["description"] = data.data.accountDetails[i].description;
          //     obj["documentName"] = data.data.accountDetails[i].documentName;
          //     obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
          //     obj["fileId"] = data.data.accountDetails[i].fileId;
          //     obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
          //     obj["id"] = data.data.accountDetails[i].id;
          //     obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
          //     obj["status"] = data.data.accountDetails[i].status;
          //     obj["type"] = data.data.accountDetails[i].type;
          //     obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
          //     this.uploadvoidchequeArray.push(obj)
          //   }
       
          // }
          // else {
          //   this.addFieldValuecheque();
          // }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please check username and password.";
          }
        }, () => { });
  }
  OverwriteEODoc(val,callMgaflag){
    // debugger
      
    //  console.log(val)
    this.eoexpiryDate1=""
    this.effectiveDate1=""
    this.documentId=val.id
    this.fileenoName="";
    this.fileId=val.fileId
    // leadId=this.leadId
    this.showCompanyDelete=false;
    this.callMgaAPI=callMgaflag
    this.mgaId=val.mgaId
    this.isOverWriteEO=true
  }
  OverwriteEODocAgency(val){
    
      // debugger
    //  console.log(val)
    this.eoexpiryDate1=""
    this.effectiveDate1=""
    this.documentId=val.id
    this.fileenoName="";
    this.fileId=val.fileId
    // leadId=this.leadId
    this.showCompanyDelete=true;
    this.agencyId=val.agencyId
  }
  OverwriteLic(licval,callMgaflag){
    // debugger
    console.log(licval)
    this.fileIdlic=licval.fileId
    this.province=licval.provinces.provinceCode
    this.licenseNumber=licval.licensesNumber
    this.licencesType=licval.type
    this.licenceId=licval.id;
    this.showCompanyDelete=false;
    this.expiryDateLic1="";
    this.effectiveDateLic1="";
    this.fileenoNameLic = "";
    this.showLicTypeonPopup=this.individualLicType;
    this.oricid=licval.oricDocumentId
    this.callMgaAPI=callMgaflag
    this.mgaId=licval.mgaId
    this.isOverWriteEO=true
    }
    OverwriteLicAgency(licval){
      // debugger
      this.agencyId=licval.agencyId
      this.fileIdlic=licval.fileId
      this.province=licval.provinces.provinceCode
      this.licenseNumber=licval.licensesNumber
      this.licencesType=licval.type
      this.showCompanyDelete=true;
      this.licenceId=licval.id;
      this.expiryDateLic1="";
      this.effectiveDateLic1="";
      this.fileenoNameLic = "";
      this.showLicTypeonPopup=this.corporateLicType;
      this.oricid=licval.oricDocumentId
    }
    isInArray(array, word) {
      return array.indexOf(word.toLowerCase()) > -1;
    }
    fileExtensionLic: any;
  fileExtensionErrorLic: boolean = false;
  fileExtensionMessageLic: any;
  FileDataListLic: any;
  licfile: File=null;
  fileenoNameLic: any;
  acceptedExtensions = ["jpg", "jpeg", "png", "pdf", "docx", "JPG", "JPEG", "PNG", "PDF", "DOCX"];
  FileSelectLic(event) {
  
    this.licfile = event.target.files[0];
    if(this.licfile.size>4194304){
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }

    if (event.target.files.length > 0) {
      this.FileDataListLic = event.target.files;
      this.fileenoNameLic = this.FileDataListLic[0].name;

      this.fileExtensionLic = this.fileenoNameLic.split('.').pop();
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionLic)) {
        this.fileExtensionErrorLic = false;
        this.fileExtensionMessageLic = ""

        this.fileExtensionErrorMsg = this.fileExtensionErrorLic
        this.fileenoNameLic = this.FileDataListLic[0].name;
      } else {
        this.fileExtensionMessageLic = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorLic = true;
         this.fileExtensionErrorMsg = this.fileExtensionErrorLic
        this.fileenoNameLic = this.fileExtensionMessageLic

      }
      //this.uploadlicenseArray[i].showemailErrorMsgone=this.fileExtensionError;
      //this.fileenoNameLic=this.fileExtensionMessage;
    } else {
      this.fileExtensionErrorMsg = false;
      this.fileenoNameLic = ""
    }
  }
  uploadlicensefile(expiryDateLic1,filelicens,licenseNumber,licencesType,province,effectiveDateLic1) {
    // console.log(uploadlic)
    
    var flag = true
    var errormsg = [];
    expiryDateLic1 = this.DatePipe.transform(expiryDateLic1, 'yyyy-MM-dd');
    effectiveDateLic1 = this.DatePipe.transform(effectiveDateLic1, 'yyyy-MM-dd');
    //if(uploadlic.showemailErrorMsgone==true){}
   // if(this.fileIdlic==null){
      if (!filelicens || filelicens.length <= 0) { this.fileExtensionErrorMsg = true; flag = false; errormsg.push('Choose File') }
  //  }
    if (!licenseNumber || licenseNumber.length <= 0) { this.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
    if(!licencesType || licencesType.length <= 0){this.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
    if (!expiryDateLic1 || expiryDateLic1.length <= 0) { this.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!province || province.length <= 0) { this.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
    if(!effectiveDateLic1 ){this.showliceffectiveDateErrorMsgone=true;  flag=false; errormsg.push('Enter Effective Date')} 

    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateLic(expiryDateLic1,filelicens,licenseNumber,licencesType,province,this.oricid,effectiveDateLic1,'LICENSES')      
      }
  else if(this.callMgaAPI==false){
        this.FileUploadLic(expiryDateLic1,filelicens,licenseNumber,licencesType,province,this.oricid,effectiveDateLic1);
        }
        else{
          this.documentType="LICENSES"
          this.FileUploadLicMGA(expiryDateLic1,filelicens,licenseNumber,licencesType,province,this.oricid,effectiveDateLic1);
        }
    }
    else {
      //this.uploadnewLicensePopup = true;
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
    }
  }
  FileUploadLic(expiryDateLic1,filelicens,licenseNumber,licencesType,province,oricDocumentId,effectiveDateLic1) {
    this.oricid=oricDocumentId
    if(this.FileDataListLic!=undefined){
    for (var i = 0; i < this.FileDataListLic.length; i++) {
      this.productPhotofile = this.FileDataListLic[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', expiryDateLic1);
        formData.append('effectiveDate', effectiveDateLic1);
        var data = sessionStorage.getItem('leadId');

        formData.append('leadId', data);
        formData.append('licencesNumber', licenseNumber);
        formData.append('lincencesName', this.fileenoNameLic);

        formData.append('licencesType', licencesType);
        formData.append('province', province);
        if(this.fileIdlic!=null){
          formData.append('fileId', this.fileIdlic);
        }
        if(this.licenceId!=null){
          formData.append('licenceId', this.licenceId);
        }
        if(this.showCompanyDelete==true){
          formData.append('agencyId ', this.agencyId);
        }

        if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }
        if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
          formData.append('oricDocumentId', this.oricid);
        }
        this.uploadImagesLic(formData)
      }
    }
  }
      else{
        const formData = new FormData();
        formData.append('expiryDate', expiryDateLic1);
        var data = sessionStorage.getItem('leadId');
        formData.append('effectiveDate', effectiveDateLic1);
        formData.append('leadId', data);
        formData.append('licencesNumber', licenseNumber);
      //  formData.append('lincencesName', this.fileenoNameLic);

        formData.append('licencesType', licencesType);
        formData.append('province', province);
        if(this.fileIdlic!=null){
          formData.append('fileId', this.fileIdlic);
        }
        if(this.licenceId!=null){
          formData.append('licenceId', this.licenceId);
        }
        if(this.showCompanyDelete==true){
          formData.append('agencyId ', this.agencyId);
        }

        if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }
        if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
          formData.append('oricDocumentId', this.oricid);
        }
        this.uploadImagesLic(formData)
      }
  }
  async uploadImagesLic(formData: FormData) {
    if(this.showCompanyDelete==false){
      // this.loading = true;
      
      if(this.licenceId==null){
        if(this.licensRequestId != null){
          this.user.submitFormService(this.config.getLicDocumentRequested, formData).subscribe((data: any) => {
            Swal.fire('', data.message, 'success');
            this.uploadnewLicensePopup=false;
            this.getLeadDoc();
            this.getLicensRequest();
            this.getEORequest();
        this.getVoidChequeRequest();  
            this.licensRequestId=null;
            //  this.showlicense=true;
            this.fileenoNameLic = "";
          
          }, err => {
      
          });
        }else{
      this.user.submitFormService(this.config.getLicDocument, formData).subscribe((data: any) => {
        // this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadnewLicensePopup=false;
        // this.getDocument();
        this.getLeadDoc();
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
    }else{
      this.user.submitFormService1(this.config.OverWriteLicences, formData).subscribe((data: any) => {
        // this.loading = false;
        this.licenceId=null;
         this.fileIdlic=null;
        Swal.fire('', data.message, 'success');
        // this.getDocument();
        // this.uploadLicensePopup = false;
        this.uploadnewLicensePopup=false;
        this.getLeadDoc();
        // this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
      }
      else{
        // this.loading = true;
      if(this.licenceId==null){
        if(this.licensRequestId != null){
          this.user.submitFormService(this.config.getLicDocumentRequested, formData).subscribe((data: any) => {
            Swal.fire('', data.message, 'success');
            this.uploadnewLicensePopup=false;
            this.getAgencyDocuments(this.agencyId,this.leadId);
            this.getLicensRequest()
            this.getEORequest();
        this.getVoidChequeRequest();  
            this.licensRequestId=null;
            this.showCompanyDelete=false;
            //  this.showlicense=true;
            this.fileenoNameLic = "";
          }, err => {
      
          });
        }
        else{
      this.user.submitFormService(this.config.uploadLicensesAgency, formData).subscribe((data: any) => {
        // this.loading = false;
        Swal.fire('', data.message, 'success');
        // this.uploadLicensePopup=false;
        this.uploadnewLicensePopup=false;
        this.getAgencyDocuments(this.agencyId,this.leadId);
        
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
    }else{
      this.user.submitFormService1(this.config.updateLicenes, formData).subscribe((data: any) => {
        // this.loading = false;
        this.licenceId=null;
         this.fileIdlic=null;
         this.uploadnewLicensePopup=false;
        Swal.fire('', data.message, 'success');
        // this.getDocument();
        // this.uploadLicensePopup = false;
        this.getAgencyDocuments(this.agencyId,this.leadId);
        // this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
      }

  }

  enofile:File=null;
  enoSizeCheck: boolean=false;
  FileSelect(event) {
    // this.FileDataList=event.target.files;
    // this.fileenoName=this.FileDataList[0].name;
    this.enofile = event.target.files[0];
    if(this.enofile.size>4194304){
      this.enoSizeCheck=true;

      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.enoSizeCheck=false;
      this.showemailErrorMsg=false;
    }

    if (event.target.files.length > 0) {
      this.FileDataList = event.target.files;
      this.fileenoName = this.FileDataList[0].name;

      this.fileExtensionENO = this.fileenoName.split('.').pop();
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionENO)) {
        this.fileExtensionErrorENO = false;
        this.fileExtensionMessageENO = ""

        this.showemailErrorMsg = this.fileExtensionErrorENO
        this.fileenoName = this.FileDataList[0].name;
      } else {
        this.fileExtensionMessageENO = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorENO = true;
        this.showemailErrorMsg = this.fileExtensionErrorENO
        this.fileenoName = this.fileExtensionMessageENO

      }

    } else {
      this.showemailErrorMsg = false;
      this.fileenoName = ""
    }

  }
  uploadEno() {
    
    var flag = true
    var errormsg = [];
    this.expiryDate = this.DatePipe.transform(this.eoexpiryDate1, 'yyyy-MM-dd');
    this.effectiveDate = this.DatePipe.transform(this.effectiveDate1, 'yyyy-MM-dd');
  //  if(this.fileId==null){
      if (!this.fileeno || this.fileeno.length <= 0 ) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
  //  }
    if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg1 = true; flag = false; errormsg.push('Enter E&O Policy Number') }
    if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }

    
    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateEO('EO')      
      }
else{
      this.FileUpload();
}
    }
    else {
      this.uploadEOPopup = !this.uploadEOPopup;
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

    }
  }
  FileUpload() {
    
    for (var i = 0; i < this.FileDataList.length; i++) {
      this.productPhotofile = this.FileDataList[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
        formData.append('policyNumber', this.policyNumber);
        var data = sessionStorage.getItem('leadId')
        formData.append('leadId', data);
        //  this.fileData=formData
        

        if(this.documentId!=null || this.fileId!=null){
          formData.append('documentId', this.documentId)
          formData.append('fileId', this.fileId)
          }

          if(this.showCompanyDelete==true){
            formData.append('agencyId ', this.agencyId);
          }
        this.uploadImages(formData)
      }

    }
  }
  showCompanyDelete:boolean=false;
  async uploadImages(formData: FormData) {
    
    if(this.showCompanyDelete==false){
    // this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.getEODocument, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.effectiveDate = "";
      // this.finalDocs = data.data;
      // this.loading = false;
      Swal.fire('', data.message, 'success');
      this.uploadEOPopup=false;
      this.getLeadDoc();

      // this.fileId = data.data.id;
      // this.import();
    }, err => {
      //  this.dismiss();
    });
  }else{
    this.user.OverWriteEO(this.config.OverWriteEO, formData).subscribe((data: any) => {
     
      this.expiryDate = "";
      this.effectiveDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      // this.finalDocs = data.data;
      // this.loading = false;
      this.documentId=null;
      Swal.fire('', data.message, 'success');
      this.uploadEOPopup=false;
      this.getLeadDoc();
    }, err => {
    });
  }
}
else{
  
  // this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.uploadEoDOcAgency, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.effectiveDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      // this.finalDocs = data.data;
      // this.loading = false;
      Swal.fire('', data.message, 'success');
      this.uploadEOPopup=false;
      // this.showExpiry = data.data.expiryDate;
      // this.showDocumentName = data.data.documentName;
      // this.showPolicyNumber = data.data.policyNumber;
       this.getAgencyDocuments(this.agencyId,this.leadId);
      // this.uploaddocs()
      // this.getLeadDoc();
      // this.fileId = data.data.id;
      // this.import();
    }, err => {
      //  this.dismiss();
    });
  }else{
    this.user.OverWriteEO(this.config.updateEoDOcAgency, formData).subscribe((data: any) => {
     
      this.expiryDate = "";
      this.effectiveDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      // this.finalDocs = data.data;
      // this.loading = false;
      this.documentId=null;
      Swal.fire('', data.message, 'success');
      this.uploadEOPopup=false;
      
      // this.showDocumentName = data.data.documentName;
      // this.showPolicyNumber = data.data.policyNumber;
      this.getAgencyDocuments(this.agencyId,this.leadId);
      // this.uploaddocs()
      // this.getLeadDoc();
    }, err => {
    });
  }
}
}
showDocViewFlag(){
  localStorage.setItem('docViewEnable','true');
}

requestLicensarray=[]
getLicensRequest(){
    this.user.getLicenseRequestCall(this.leadId,'LINCENCES').pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.requestLicensarray=[]
        this.requestLicensarray=data.data
        }else{
        this.requestLicensarray=[]
        }
      },error=>{
          },()=>{});
  }
  licensRequestId: any;
  clickOnRequest(item){
    this.licenceId=null;
   this.licensRequestId=item.id;
   this.province=undefined
    this.licenseNumber="";
    this.expiryDateLic1="";
    this.effectiveDateLic1=""
     this.eoexpiryDate1=""
    this.effectiveDate1=""
    this.licencesType=undefined
  //  this.uploadnewLicensePopup = true;
   this.fileenoNameLic=""
   this.callMgaAPI=false;
   this.showCompanyDelete=false;
   this.showLicTypeonPopup=this.individualLicType;
  }
  clickOnRequestAgency(item){
    this.agencyId=item.agencyMGA.id
    this.licenceId=null;
    this.licensRequestId=item.id;
    this.province=undefined
    this.licenseNumber="";
    this.expiryDateLic1="";
    this.effectiveDateLic1=""
    this.eoexpiryDate1="";
    this.effectiveDate1=""
    this.licencesType=undefined
  //  this.uploadnewLicensePopup = true;
   this.showCompanyDelete=true;
   this.callMgaAPI=false;
   this.fileenoNameLic=""
   this.showLicTypeonPopup=this.corporateLicType;
  }
  showLoginPopup:boolean=false;
  errormsg:boolean=false;
  errorLogin:any;
  username:any;
  password:any;
  onClickLoginPopup(){
    if(this.username=="Travelance" && this.password=="Admin@123#@!"){
      this.showLoginPopup=false;
      this.errormsg=false;
      if(this.agentcodedata1[0].isAddendumAccepted==false){
        this.checkPrivcyPolicy=false;
        this.showAddendumPopup=true;
      }else{
        this.showAddendumPopup=false;
        this.router.navigate(['/dashboard/sales-home']);
      }
    }else{
      this.errormsg=true;
      this.errorLogin="Please enter Username / Password";
    }
  }
  showAddendumPopup:boolean=false;
  checkPrivcyPolicy:boolean=false;
  goToB2BPortal(){
    if(this.checkPrivcyPolicy==true){
      this.user.acceptAddendumAgentID(this.agentcodedata1[0].id,this.checkPrivcyPolicy,this.leadId).pipe().subscribe(
      data => {
        this.showAddendumPopup=false;
        var testOVr=sessionStorage.getItem('agencyCodeSalesPortal');
      sessionStorage.removeItem('checkOVRInAgencyCode');
      testOVr=testOVr.toLowerCase();
      if (testOVr.indexOf('ovr') > -1){
        sessionStorage.setItem('checkOVRInAgencyCode', 'true');
        this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode')
      }else{
        sessionStorage.setItem('checkOVRInAgencyCode', 'false');
        this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode')
      }
      if(this.checkOVRInAgencyCode=='true'){
        this.router.navigate(['/dashboard/forms']);
      }else{
        this.router.navigate(['/dashboard/sales-home']);
      }
      },error=>{
          },()=>{});
    }
  }
  checkOVRInAgencyCode:any;
  goToB2BPortalFromGreenButton(){
    if(this.agentcodedata1[0].isAddendumAccepted==false){
      this.showAddendumPopup=true;
      this.checkPrivcyPolicy=false;
    }else{
      var testOVr=sessionStorage.getItem('agencyCodeSalesPortal');
      sessionStorage.removeItem('checkOVRInAgencyCode');
      testOVr=testOVr.toLowerCase();
      if (testOVr.indexOf('ovr') > -1){
        sessionStorage.setItem('checkOVRInAgencyCode', 'true');
        this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode')
      }else{
        sessionStorage.setItem('checkOVRInAgencyCode', 'false');
        this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode')
      }
      this.showAddendumPopup=false;
      if(this.checkOVRInAgencyCode=='true'){
        this.router.navigate(['/dashboard/forms']);
      }else{
        this.router.navigate(['/dashboard/sales-home']);
      }
    }
  }
  showHolidayPopup(){
    this.holidayhourPopup=false;
    localStorage.setItem('holidayhourPopup',JSON.stringify(false));
    this.acceptBrokerStatement();
  }
  // payment module api
  PaymentModuleData(){
    var flag = true
    var errormsg = [];
    if(this.planType == 'Zurich'){
      if (this.paymentType == "CreditCard"){
        
        // if ( !this.cardHolderName || this.cardHolderName.length <= 0 ) { this.BankNameOnCardErrMsg=true; flag = false;}
        if ( !this.expDate || this.expDate.length <= 0 ) { this.BankExpDateErrMsg=true; flag = false;}
        if ( !this.payAmount || this.payAmount.length <= 0 ) { this.BankAmountErrMsg=true; flag = false;}
        if ( !this.ccNum || this.ccNum.length <= 0 ) { this.BankCreditCardErrMsg=true; flag = false;}
      }
      if (this.paymentType == "ETRANSFER"){
        
        if ( !this.dateTransfer || this.dateTransfer.length <= 0 ) { this.DatetransferErrMsg=true; flag = false;}
        if ( !this.payAmount || this.payAmount.length <= 0 ) { this.BankAmountErrMsg=true; flag = false;}
      }
      if (this.paymentType == "AGENCYCODETRANSFER"){
        if ( !this.payAmount || this.payAmount.length <= 0 ) { this.BankAmountErrMsg=true; flag = false;}
      }
    }else{
      // if (this.paymentType == "CreditCard"){
        
      //   // if ( !this.cardHolderName || this.cardHolderName.length <= 0 ) { this.BankNameOnCardErrMsg=true; flag = false;}
      //   if ( !this.expDate || this.expDate.length <= 0 ) { this.BankExpDateErrMsg=true; flag = false;}
      //   if ( !this.payAmount || this.payAmount.length <= 0 ) { this.BankAmountErrMsg=true; flag = false;}
      //   if ( !this.ccNum || this.ccNum.length <= 0 ) { this.BankCreditCardErrMsg=true; flag = false;}
      //   // if ( !this.agencyCodeORIC || this.agencyCodeORIC.length <= 0 ) { this.BankAgencyOricErrMsg=true; flag = false;}
      // }
      if (this.paymentType == "ETRANSFER"){
        
        if ( !this.dateTransfer || this.dateTransfer.length <= 0 ) { this.DatetransferErrMsg=true; flag = false;}
        if ( !this.payAmount || this.payAmount.length <= 0 ) { this.BankAmountErrMsg=true; flag = false;}
        if ( !this.agencyCodeORIC || this.agencyCodeORIC.length <= 0 ) { this.BankAgencyOricErrMsg=true; flag = false;}
      }
    }
   
    if(flag==true){
      var request={}
      var owingBalaceConverted = this.payAmount;
      var intValue = JSON.parse(owingBalaceConverted);
      var actualBalaceConverted = this.actualAmount;
      var intValueActualBal = JSON.parse(actualBalaceConverted);
    if(intValueActualBal >= intValue){
      this.AmountError=false
      if(this.planType == 'Zurich'){
        if (this.paymentType == "CreditCard"){
          var obj9={}
          obj9["ccNum"]= this.ccNum;
          obj9["expDate"]= this.expDate;
          this.creditCardInfo=obj9;
          request = {
            "creditCardInfo": this.creditCardInfo,
            "agentCodeId": this.agentCodeId,
            // "cardHolderName": this.cardHolderName,
            "leadId": this.leadId,
            "payAmount": this.payAmount,
            "totalOwingAmount": 0,
            "paymentMethod" : this.paymentType,
            "planType" : this.planType,
          }
        }
       else if (this.paymentType == "ETRANSFER"){
          request = {
            "agentCodeId": this.agentCodeId,
            "payAmount": this.payAmount,
            "paymentMethod" : this.paymentType,
            "dateOfTransferSubmited": this.dateTransfer,
            "leadId": this.leadId,
            "planType" : this.planType,
          }
        }
        else if (this.paymentType == "AGENCYCODETRANSFER"){
          request = {
            "agentCodeId": this.agentCodeId,
            "payAmount": this.payAmount,
            "paymentMethod" : this.paymentType,
            "agencyCode" : this.agencyCode,
            "agencyName" : this.agencyName,
            "transferAgentCodeId" : this.getAgentCodeForAgency,
            "leadId": this.leadId,
            "planType" : this.planType,
          }
        }
      }
     else{
      if (this.paymentType == "CreditCard"){
        var obj9={}
        obj9["ccNum"]= this.ccNum;
        obj9["expDate"]= this.expDate;
        this.creditCardInfo=obj9;
        request = {
          "creditCardInfo": this.creditCardInfo,
          "agentCodeId": this.getAgentCodeForAgencyORIC,
          // "cardHolderName": this.cardHolderName,
          "leadId": this.leadId,
          "payAmount": this.payAmount,
          "totalOwingAmount": 0,
          "paymentMethod" : this.paymentType,
          "planType" : this.planType,
          "oricUniqueId" :  this.uniqueIdOfOwing,
          "agencyCode" :  this.overridecode,
        }
      }
     else if (this.paymentType == "ETRANSFER"){
        request = {
          "agentCodeId": this.getAgentCodeForAgencyORIC,
          "payAmount": this.payAmount,
          "paymentMethod" : this.paymentType,
          "dateOfTransferSubmited": this.dateTransfer,
          "leadId": this.leadId,
          "planType" : this.planType,
          "oricUniqueId" :  this.uniqueIdOfOwing,
          "agencyCode" :   this.overridecode,
        }
      }
      }
     this.loading = true;
     this.isButtonDisabled = true;
      this.base.callPostService(this.config.paymentModule, request).subscribe((data: any) => {
        if(data.status == true){
          this.blockUI.stop(); 
          this.isButtonDisabled = false;
          this.uploadPaymentMudulePopup =false;
          this.loading = false;
          this.getPaymentModuleDetails();
          
          Swal.fire({
            // title: 'Are you sure?',
            text: data.message,
             icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#2778c4 !important;',
            // cancelButtonColor: '#d33',
            confirmButtonText: 'Ok'
          }).then((result) => {
            if(result.isConfirmed){
              this.router.navigate(['/account-info']);
               sessionStorage.setItem("tab3open",'true')
              this.getTransferAgentCodes();
            }
          })
          // Swal.fire('', data.message, 'success');
          // this.router.navigate(['/account-info']);
        } else{
          Swal.fire('', data.data, 'error');
          this.blockUI.stop(); 
          this.isButtonDisabled = false;
        }
      }, error => {
      }, () => { });
    }else{
      this.AmountError=true;
    }
   }else{
    this.msg = errormsg.toString();
   }
  }
  // End payment module api
  getPaymentModuleDetails(){
    
    this.getBalance=[];
    // this.getAgencyCode=[];
    this.user.getPaymentModuleDetails(this.leadId).pipe()
    .subscribe(
      data => {
        console.log(data);
        if(data.success==false){

        }else{
          this.getBalance = data.data;
          this.selectedAgencyCode = data.data;
        }
      }, error => {
      }, () => { });
  }
  newArray=[]
  uploadPayModule(item){
    
    // this.blockUI.start(); 
    this.agentCodeId=item?.agentId;
    // this.agencyCode=item?.agencyCode;
    this.planType=item?.planType;
    this.seleectedagencyCode=item?.agencyCode;
    this.payAmount=item?.owingBalance;
    this.actualAmount=item?.owingBalance;
    this.newArray=this.transferagentcodedata
    var data=this.transferagentcodedata.filter(item1=>item1.agencyCode!=item.agencyCode)
    this.newArray=data
    this.uploadPaymentMudulePopup = true;
  }
  ValidateCreditCardNumber(){
    var ccNum = this.ccNum;
  
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/; 
    var isValid = false;
    try{this.ccNum=this.ccNum.trim()}catch{}
    if(!this.ccNum){this.BankCreditCardErrMsg = true} else{this.BankCreditCardErrMsg = false}
    if (visaRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="VISA"
    } else if(mastercardRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="MasterCard"
    } else if(amexpRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="Amex"
    } else if(discovRegEx.test(ccNum)) {
      isValid = true;
      this.cardType="Discover"
    }else{
      isValid=false;
    }
    if(isValid==true){
    this.cardError=false;
    }else{
    this.cardError=true;
    }
  }
  cardNoClick(){
    this.cardNoValid=false;
  }
  amountInput(){
    
    try{this.payAmount=this.payAmount.trim()}catch{}
    if(!this.payAmount){this.BankAmountErrMsg = true} else{this.BankAmountErrMsg = false}
    var owingBalaceConverted = this.payAmount;
      var intValue = JSON.parse(owingBalaceConverted);
      var actualBalaceConverted = this.actualAmount;
      var intValueActualBal = JSON.parse(actualBalaceConverted);

    if(intValue > intValueActualBal){
    this.AmountError=true
    }
    else{
      this.AmountError=false
    }
  }
  BankNameOnCardErrMsgred(){
    try{this.cardHolderName=this.cardHolderName.trim()}catch{}
    if(!this.cardHolderName){this.BankNameOnCardErrMsg = true} else{this.BankNameOnCardErrMsg = false}
  }
  DatetransferErrMsgred(){
    try{this.dateTransfer=this.dateTransfer.trim()}catch{}
    if(!this.dateTransfer){this.DatetransferErrMsg = true} else{this.DatetransferErrMsg = false}
  }
  BankExpDateErrMsgred(){
    try{this.expDate=this.expDate.trim()}catch{}
    if(!this.expDate){this.BankExpDateErrMsg = true} else{this.BankExpDateErrMsg = false}
  }
  ptype:any
  creditCardPopupDetails(a){
    
    this.paymentType = a;
    
    if(a=='CreditCard'){
      
    this.creditCardPopup =true;
    this.payAmount = this.actualAmount;
    this.etransferPopup =false;
    this.fromAnotherAgencyCode =false;
    this.BankAmountErrMsg = false;
    this.BankExpDateErrMsg = false;
    this.BankCreditCardErrMsg = false;
    this.AmountError = false;
    }
    if(a=='ETRANSFER'){
      
      this.etransferPopup =true;
      this.payAmount = this.actualAmount;
      this.creditCardPopup =false;
      this.fromAnotherAgencyCode =false;
      this.BankAmountErrMsg = false;
      this.BankExpDateErrMsg = false;
      this.BankCreditCardErrMsg = false;
      this.AmountError = false;
      this.dateTransfer = new Date();
      }
      if(a=='AGENCYCODETRANSFER'){
        
        this.transferAgentCodeId =this.transferAgentCodeId;
        this.fromAnotherAgencyCode =true;
        this.payAmount = this.actualAmount;
        this.creditCardPopup =false;
        this.etransferPopup =false;
        this.BankAmountErrMsg = false;
        this.BankExpDateErrMsg = false;
        this.BankCreditCardErrMsg = false;
        this.AmountError = false;
        }
  }
  makePayment(){
    
    this.creditCardPopup=false;
    this.etransferPopup=false;
    this.fromAnotherAgencyCode=false;
    this.uploadPaymentMudulePopup=false;
    this.isButtonDisabled = false;
    this.ptype=null;
    this.BankAmountErrMsg=false;
    this.cardHolderName = '';
    this.ccNum = '';
    this.expDate = '';
    this.dateTransfer = '';
    this.AmountError = false;
    this.BankNameOnCardErrMsg = false;
    this.BankCreditCardErrMsg = false;
    this.BankExpDateErrMsg = false; 
  }
  agId: any;
  getAgentCodes(a){
    
    for(let i=0;i<this.transferagentcodedata.length;i++){
      if(this.transferagentcodedata[i].agencyCode == a){
          this.getAgentCodeForAgency = this.transferagentcodedata[i].id;
          this.getAgencyName = this.transferagentcodedata[i].agencyName;
      }
    }
  }
  closeMobileResponsivePopup(){
    this.showMobileResponsivePopup=false;
    sessionStorage.setItem('showMobileResponsivePopup',JSON.stringify(false));
  }
  getTransferAgentCodes(){
  
    this.user.getTransferAgencyCode(this.leadId).pipe()
    .subscribe(
      data => {
        
       this.transferagentcodedata=data?.data;
      }, error => {
  
        if (error.status == 400 || error.status == 417) {
          this.error = error.error.data;
        }
        else {
          this.error = "Something went wrong. Please check username and password.";
        }
      }, () => { });
    }
  clickOnRequestMga(item){
    this.mgaId=item.mga.id
    this.licenceId=null;
    this.licensRequestId=item.id;
    this.province=undefined
    this.licenseNumber="";
    this.expiryDateLic1="";
    this.effectiveDateLic1="";
     this.eoexpiryDate1=""
    this.effectiveDate1=""
    this.licencesType=undefined
    this.fileenoNameLic=""
  this.callMgaAPI=true;
  this.showCompanyDelete=false
   this.showLicTypeonPopup=this.MgaLicType;
  }
  FileUploadLicMGA(expiryDateLic1,filelicens,licenseNumber,licencesType,province,oricDocumentId,effectiveDateLic1) {
    this.oricid=oricDocumentId
    if(this.FileDataListLic!=undefined){
    for (var i = 0; i < this.FileDataListLic.length; i++) {
      this.productPhotofile = this.FileDataListLic[i];
      if (this.productPhotofile != null) {
        
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', expiryDateLic1);
        formData.append('effectiveDate', effectiveDateLic1);
        formData.append('leadId', this.leadId);
        formData.append('DocNumber', licenseNumber);
        formData.append('docName', this.fileenoNameLic);
        formData.append('licencesType', licencesType);
        formData.append('province', province);
        // formData.append('agencyId',this.agencyId)
        formData.append('documentFor',"MGA")
        
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
       
        formData.append('mgaId',this.mgaId)
        if(this.fileIdlic!=null){
          formData.append('fileId', this.fileIdlic);
        }
 if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }
  if(this.licenceId!=null){
    if(this.isOverWriteEO==true){
      formData.append('documentId',this.licenceId)
      }
        
      }
      if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
        formData.append('oricDocumentId', this.oricid);
      }
      this.uploadImagesLicMGA(formData)
    }
    
    }
    
  }
      else{
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', expiryDateLic1);
        formData.append('effectiveDate', effectiveDateLic1);
  
        formData.append('leadId', this.leadId);
        formData.append('DocNumber', licenseNumber);
        formData.append('docName', this.fileenoNameLic);
        formData.append('licencesType', licencesType);
        formData.append('province', province);
        // formData.append('agencyId',this.agencyId)
        formData.append('documentFor',"MGA")
        
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
       
        formData.append('mgaId',this.mgaId)
        if(this.fileIdlic!=null){
          formData.append('fileId', this.fileIdlic);
        }
 if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }
  if(this.licenceId!=null){
    if(this.isOverWriteEO==true){
      formData.append('documentId',this.licenceId)
      }
        
      }
      if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
        formData.append('oricDocumentId', this.oricid);
      }
      this.uploadImagesLicMGA(formData)
  }
  }
  async uploadImagesLicMGA(formData: FormData) {
    
    if(this.licenceId==null){
      if(this.licensRequestId != null){
    this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      
      Swal.fire('', data.message, 'success');
      this.isOverWriteEO=false
      this.uploadnewLicensePopup=false;
      this.getMGADocuments(this.mgaId,this.mgaIndex);
      this.getLicensRequest();
      this.getEORequest();
        this.getVoidChequeRequest();  
      this.licensRequestId=null;
      //  this.showlicense=true;
      this.fileenoNameLic = "";
    }, err => {
  
    });
  }else{
    this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      Swal.fire('', data.message, 'success');
      this.uploadnewLicensePopup=false;
      this.isOverWriteEO=false
      this.getMGADocuments(this.mgaId,this.mgaIndex);
      this.licensRequestId=null;
      //  this.showlicense=true;
      this.fileenoNameLic = "";
    
    }, err => {
  
    });
  }
}
else{
    this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      Swal.fire('', data.message, 'success');
      this.uploadnewLicensePopup=false;
      this.isOverWriteEO=false
      this.getMGADocuments(this.mgaId,this.mgaIndex);
      this.licensRequestId=null;
      //  this.showlicense=true;
      this.fileenoNameLic = "";
    
    }, err => {
  
    });
  }
  }
  getDocumentsMga=[];
  getLicencesMga=[];
  getVoidChequeMga=[];
  getMGADocuments(MGAid,index){
     this.getDocumentsMga=[];
  this.getLicencesMga=[];
  this.getVoidChequeMga=[];

      for(let i=0; i<this.brokerLinkMGA.length;i++){

       MGAid=this.brokerLinkMGA[i].mgaId
    this.user.getMGAdocument(MGAid,this.leadId).pipe()
    .subscribe(
      data => {
        this.corporateLicType=[];
        this.MgaLicType=[];
        this.individualLicType=[];
        this.showLicTypeonPopup=[];
        this.licencesTypes = data.data.licencesTypes;
        for(let i=0; i<data.data.licencesTypes.length; i++){
          
          var testOVr = data.data.licencesTypes[i].toLowerCase();
          if (testOVr.slice(-2)=='dr' || testOVr.indexOf('corporate') > -1){
            if(data.data.licencesTypes[i]!=="General 3 - DR"){
            this.corporateLicType.push(data.data.licencesTypes[i])
            this.MgaLicType.push(data.data.licencesTypes[i])
          } 
        }
          if(testOVr.indexOf('corporate') > -1){
            
          }
          else{
            this.individualLicType.push(data.data.licencesTypes[i])
          }
        }
        if(data.data.documents != null){
          this.getDocumentsMga.push(data.data.documents); 
        }
        if(data.data.licences != null){
          this.getLicencesMga = data.data.licences;
        }
        if (this.leadType == 'Travel Agent') {
          this.getLicencesMga = this.getLicencesMga.filter(licence => {
              // Check the provinceCode for each licence and remove if it's not 'NS'
              return licence.provinces.provinceCode === 'NS';
          });
      }
        // if(data.data.accountDetails != null){
        //   this.getVoidChequeMga = data.data.accountDetails;
        // }
            if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidChequeMga.push(voidChequeaccountDetails);
          });
        }
      
      }, error => {
       
      }, () => { });
    }
  
  }
    acceptBrokerStatement(){
      
      const todaysDate = new Date();    
    const previousDate1 = this.DatePipe.transform(todaysDate, 'yyyy-MM-dd HH:mm');
      this.user.acceptBrokerStatement(previousDate1).pipe()
      .subscribe(
        data => {
         
        }, error => {
       }, () => { });
      }
      getLastTrainingDate(){      
        this.user.getLastTrainingDate("LEAD",this.leadId).pipe()
        .subscribe(
            data => {
              if(data.status==true){
                this.lastTrainingDate=this.DatePipe.transform(data.data.sessionDate, "MM/dd/yyyy");
                this.isTraningExpired=data?.data?.isTraningExpired;
                this.nextSessionDate=this.DatePipe.transform(data?.data?.nextSessionDate, "MM/dd/yyyy");
              }
              
              
            },error=>{
            },()=>{});
          }
  showpricePopup() {    
    this.pricePopup = false;
    localStorage.setItem('pricePopup', JSON.stringify(true));
    this.acceptisprates();
  }

  acceptisprates() {    
    this.user.acceptisprates().pipe()
      .subscribe(
        data => {

        }, error => {
        }, () => { });
  }

  getMgaOVRBalanceOwing(){    
    this.getBalance=[];  
    this.user.getMgaOVRBalanceOwing(this.leadId).pipe()
    .subscribe(
        data => {
          if(data.status==true){
            this.lastTrainingDate=this.DatePipe.transform(data.data.sessionDate, "MM/dd/yyyy");
            this.isTraningExpired=data?.data?.isTraningExpired;
            this.nextSessionDate=this.DatePipe.transform(data?.data?.nextSessionDate, "MM/dd/yyyy");
            this.getOricOwing = data.data;
          }
          
          
        },error=>{
        },()=>{});
      }       
      uploadPayModuleORIC(item){
        this.overridecode=item?.overrideCode
        this.uniqueIdOfOwing=item?.uniqueIdOfOwing
        this.agentCodeId=item?.agentId;
        this.planType=item?.planType;
        this.seleectedagencyCode=item?.agencyCode;
        this.payAmount=item?.owingBalance;
        this.actualAmount=item?.owingBalance;
        this.newArray=this.transferagentcodedata
        var data=this.transferagentcodedata.filter(item1=>item1.agencyCode!=item.agencyCode)
        this.newArray=data
        this.uploadPaymentMudulePopupORIC = true;
      }
    
     redirectDocTab(){
      this.router.navigate(['/account-info']);
      sessionStorage.setItem("tab1open",'true')
     }
     getMisc:[];
     urlSafe: SafeResourceUrl;
     getMiscDocument(){
      //debugger
      this.user.getMiscDocument(this.leadId).pipe()
    .subscribe(
        data => {
            this.getMisc = data.data;
            this.urlSafe = data?.data[0]?.embeddedSigningUrl;
        },error=>{
            },()=>{});
    }
    makePaymentORIC(){
    
      this.creditCardPopup=false;
      this.etransferPopup=false;
      this.fromAnotherAgencyCode=false;
      this.uploadPaymentMudulePopupORIC=false;
      this.isButtonDisabled = false;
      this.ptype=null;
      this.BankAmountErrMsg=false;
      this.cardHolderName = '';
      this.ccNum = '';
      this.expDate = '';
      this.dateTransfer = '';
      this.AmountError = false;
      this.BankNameOnCardErrMsg = false;
      this.BankCreditCardErrMsg = false;
      this.BankExpDateErrMsg = false; 
    }
    isCollapsed: boolean = false; // Collapsed state initially set to false

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed; // Toggle the state
  }
  goToAdminDashboard(itemLinkMGA){
    this.isCollapsed=false
    sessionStorage.removeItem('MgaIddropdown')
    sessionStorage.setItem('MgaIddropdown',itemLinkMGA.mgaId);
    this.router.navigate(['/dashboard/dashboard-mga']);
  }
  showPortalAnnouncementPopup(val) {    
    //debugger
    this.hideSalesContest = !this.hideSalesContest
    localStorage.setItem('PortalAnnouncement', JSON.stringify(val));
    this.acceptPortalAnnouncement();
  }
  
    acceptPortalAnnouncement() {    
      this.user.acceptPortalAnnouncement().pipe()
        .subscribe(
          data => {
  
          }, error => {
          }, () => { });
    }
    closeclick(){
      // localStorage.setItem('PortalAnnouncement', JSON.stringify(true));
      this.PortalAnnouncement = false
    }
    LeadActivated: any;
     btnPopupName ="Save"
     allowUser: boolean=false;
     voidSizeCheck: boolean=false;
     showemailErrorMsg1: boolean = false;
    uploadEno1(item, i) {
      //debugger
      if(this.LeadActivated=="Activated"){
        item.fileId=null
      }
      //
      var flag = true
      var errormsg = [];
      this.msg =null
this.msgfinal=null
         // banking info
         try{this.transitNo=this.transitNo.trim()}catch{}
         try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
         try{this.accountNo=this.accountNo.trim()}catch{}
         try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
         
         
        //  if(this.allowUser == true){
          
        //   if (this.btnPopupName == "Confirm"){
        //     if(this.accountNo==this.confirmaccountNo){
        //     if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;}
        //     if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;}
        //     if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false;}
        //     if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false;}
        //     if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
        //   }
        //   else{
        //     flag=false
        //   }
        //   }
        //  }else{
        //   this.bankInfoErrmsg = true;
        //   flag = false;
        //  }
        //  if(this.allowUser == true){
          if (this.btnPopupName == "Save"){
            if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
              if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
              if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
              if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
              if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number.')}
              if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
              // if ( this.accountConfirmFlag = false) { this.confirmAccountNumberMatch=true;flag = false;  errormsg.push('Account Number and Confirm Account Number does not match.');}
              // errormsg.push('Account Number and Confirm Account Number does not match.');
            if(item.fileId!==undefined && item.fileId!==null){
              if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
            }else{
              if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
            }
          // }else{
          //   errormsg.push('Account Number and Confirm Account Number does not match.');
          //   flag=false;
          //   // if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number')}
          //   // if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number')}
          //   // if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number')}
          //   // if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number')}
          //   // if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please check the acknowledgement checkbox.')}
          //   // errormsg.push('Account Number and Confirm Account Number does not match.');
          // }
          if(this.bankinfoChecked==true){
            this.bankInfoErrmsg=false
          }else{
            this.bankInfoErrmsg=true;
            flag = false;
          }
          }else{
            if (this.btnPopupName == "Confirm"){
              if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
                if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
                if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
                if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
                if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number.')}
                if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
                // if (  this.accountConfirmFlag = false) { this.confirmAccountNumberMatch=true;flag = false;  errormsg.push('Account Number and Confirm Account Number does not match.');}
              // if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
              if(item.fileId!==undefined && item.fileId!==null){
                if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
              }else{
                if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
              }
            if(this.bankinfoChecked==true){
              this.bankInfoErrmsg=false
            }else{
              this.bankInfoErrmsg=true;
              flag = false;
            }
            
            }else{
              flag = false;
              if ( !this.bankinfoChecked) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
            }
          }
        //  }else{
        //   this.bankInfoErrmsg = true;
        //   flag = false;
        //  }
      if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
      // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 
  
      if (flag == true) {
        if(this.isDocumentRequested==true){
          this.RequestedDocumentAddUpdateVoid(item, i,'VOID_CHEQUE')      
        }
  else if(this.callMgaAPI==false){
          this.FileUpload1(item, i);
        }else{
          this.documentType="VOID_CHEQUE"
        this.FileUploadVoidMGA(item, i);
        }
      }
      else {
        if(this.bankinfoChecked==true){
          this.bankInfoErrmsg=false
        }else{
          this.bankInfoErrmsg=true;
          flag = false;
        }
        // if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number')}
        // if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number')}
        // if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number')}
        // if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number')}
        // if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
        this.msg = errormsg.toString();
        // this.msgfinal = this.msg.replaceAll(",", '<br />');
        Swal.fire("", "Please complete the following mandatory field(s):"  +","+"<br>" + this.msg, 'warning')
  
      }
    
      
    }
    confirmaccountNo: any;
    confirmaccountNoErrMsg: boolean=false;
    transitNo: any;
    financialInstitutionNo: any ;
    accountNo: any;
    transitNoErrMsg: boolean=false;
    financialInstitutionNoErrMsg: boolean=false;
    accountNoErrMsg: boolean=false;
    bankName : any;
    uploadLicensePopup : any;
  viewUploadedLicensePopup : any;
  viewUploadedEOPopup : any;
  uploadVoidChequePopup :any;
  bankinfoChecked: boolean=false;
  bankInfoErrmsg: boolean=false;
    cancelBtnPopup(){
      this.uploadVoidChequePopup = false;
      this.bankInfoErrmsg = false;
      this.bankName = this.bankNm;
      this.transitNo = this.transitNm;
      this.financialInstitutionNo = this.financialInstNumber;
      this.accountNo = this.accNm;
      this.confirmaccountNo = this.accNm;
      this.prepoulateBankInfo();
    }
    BankInfo :boolean = false;
    bankNm: any;
    holdeNm: any;
    holderNm: any;
    branchAdr: any;
    transitNm: any;
    financialInstNumber: any;
    accNm: any;
    confirmAccNo: any;
    closeBankInfoPopup(){
      //
      this.BankInfo = false;
      this.bankName = this.bankNm;
      this.transitNo = this.transitNm;
      this.financialInstitutionNo = this.financialInstNumber;
      this.accountNo = this.accNm;
      this.confirmaccountNo = this.accNm;
    }
    FileUpload1(item, k) {
      //
      if(this.allowUser == true){
        if(this.btnPopupName == "Save"){
          //
          for (var i = 0; i < this.FileDataList1.length; i++) {
            this.productPhotofile1 = this.FileDataList1[i];
            if (this.productPhotofile1 != null) {
              const formData = new FormData();
              formData.append('file', this.productPhotofile1);
              formData.append('accountNumber', this.accountNo);
              formData.append('confirmaccountNo', this.confirmaccountNo);
              formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
              formData.append('transitNumber', this.transitNo);
              var data = sessionStorage.getItem('leadId')
              formData.append('leadId', data);
              //  this.fileData=formData
              if(this.fileIdvoid!=null || this.voidchequeId!=null){
                formData.append('fileId', this.fileIdvoid);
                formData.append('voidChequeId', this.voidchequeId);
              }
              if(this.showCompanyDelete==true){
               formData.append('agencyId ', this.agencyId);
             }
              this.uploadImages1(formData, k)
            }
          }
        }
  
        if(this.btnPopupName == "Confirm"){
          //
          if(this.FileDataList1!=undefined){
            this.productPhotofile1 = this.FileDataList1[0];
          }
              const formData = new FormData();
              formData.append('accountNumber', this.accountNo);
              formData.append('confirmaccountNo', this.confirmaccountNo);
              formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
              formData.append('transitNumber', this.transitNo);
              var data = sessionStorage.getItem('leadId')
              formData.append('leadId', data);
              //  this.fileData=formData
              if(this.fileIdvoid!=null || this.voidchequeId!=null){
                formData.append('fileId', this.fileIdvoid);
                formData.append('voidChequeId', this.voidchequeId);
              }
              if(this.showCompanyDelete==true){
               formData.append('agencyId ', this.agencyId);
             }
             if(this.productPhotofile1!=undefined){
              formData.append('file', this.productPhotofile1);
            }
              this.uploadImages1(formData, k)
            
        }
        }else{
          if(this.FileDataList1!=undefined){
          for (var i = 0; i < this.FileDataList1.length; i++) {
            this.productPhotofile1 = this.FileDataList1[i];
            if (this.productPhotofile1 != null) {
              const formData = new FormData();
              formData.append('file', this.productPhotofile1);
              formData.append('accountNumber', this.accountNo);
              formData.append('confirmaccountNo', this.confirmaccountNo);
              formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
              formData.append('transitNumber', this.transitNo);
              var data = sessionStorage.getItem('leadId')
              formData.append('leadId', data);
              //  this.fileData=formData
              if(this.fileIdvoid!=null || this.voidchequeId!=null){
                formData.append('fileId', this.fileIdvoid);
                formData.append('voidChequeId', this.voidchequeId);
              }
              if(this.showCompanyDelete==true){
               formData.append('agencyId ', this.agencyId);
             }
              this.uploadImages1(formData, k)
            }
          }
        }
        // }
      
    }
        // if(this.allowUser == true){
        //     const formData = new FormData();
        //     formData.append('file', this.productPhotofile1);
        //     formData.append('accountNumber', this.accountNo);
        //     formData.append('confirmaccountNo', this.confirmaccountNo);
        //     formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
        //     formData.append('transitNumber', this.transitNo);
        //     var data = this.leadId
        //     formData.append('leadId', data);
        //     //  this.fileData=formData
        //     if(this.fileIdvoid!=null || this.voidchequeId!=null){
        //       formData.append('fileId', this.fileIdvoid);
        //       formData.append('voidChequeId', this.voidchequeId);
        //     }
        //     if(this.showCompanyDelete==true){
        //      formData.append('agencyId ', this.agencyId);
        //    }
        //     this.uploadImages1(formData, k)
        //   }else{
        //     if(this.FileDataList1!=undefined){
        //       for (var i = 0; i < this.FileDataList1.length; i++) {
        //         this.productPhotofile1 = this.FileDataList1[i];
        //         if (this.productPhotofile1 != null) {
        //         const formData = new FormData();
        //         formData.append('file', this.productPhotofile1);
        //         formData.append('accountNumber', this.accountNo);
        //         formData.append('confirmaccountNo', this.confirmaccountNo);
        //         formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
        //         formData.append('transitNumber', this.transitNo);
        //         var data = this.leadId
        //         formData.append('leadId', data);
        //         //  this.fileData=formData
        //         if(this.fileIdvoid!=null || this.voidchequeId!=null){
        //           formData.append('fileId', this.fileIdvoid);
        //           formData.append('voidChequeId', this.voidchequeId);
        //         }
        //         if(this.showCompanyDelete==true){
        //          formData.append('agencyId ', this.agencyId);
        //        }
        //         this.uploadImages1(formData, k)
        //       }
        //     }
        //   }
        // }
      //   else{
      //   for (var i = 0; i < this.FileDataList1.length; i++) {
      //     this.productPhotofile1 = this.FileDataList1[i];
      //     if (this.productPhotofile1 != null) {
      //       const formData = new FormData();
      //       formData.append('accountNumber', this.accountNo);
      //       formData.append('confirmaccountNo', this.confirmaccountNo);
      //       formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      //       formData.append('transitNumber', this.transitNo);
      //       formData.append('file', this.productPhotofile1);
      //       var data = this.leadId
      //       formData.append('leadId', data);
      //       if(this.fileIdvoid!=null || this.voidchequeId!=null){
      //         formData.append('fileId', this.fileIdvoid);
      //         formData.append('voidChequeId', this.voidchequeId);
      //       }
      //       if(this.showCompanyDelete==true){
      //         formData.append('agencyId ', this.agencyId);
      //       }
      //       this.uploadImages1(formData, k)
      //     }
    
      //   }
      // }
    
    }
    FileDataList1: any;
    productPhotofile1: any;
    fileIdvoid:any;
    voidchequeId:any;
    showDocumentName1: any;
    fileenoName1: any;
    uploadvoidchequeArray: Array<any> = [];
    FileUploadVoidMGA(item, k) {
      
      if(this.FileDataList1!=undefined){
      for (var i = 0; i < this.FileDataList1.length; i++) {
        this.productPhotofile1 = this.FileDataList1[i];
        if (this.productPhotofile1 != null) {
          const formData = new FormData();
          formData.append('file', this.productPhotofile1);
          formData.append('leadId', this.leadId);
          // formData.append('agencyId',this.agencyId)
          //  this.fileData=formData
       formData.append('accountNumber', this.accountNo);
    formData.append('confirmaccountNo', this.confirmaccountNo);
    formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
    formData.append('transitNumber', this.transitNo);
    formData.append('bankNumber',this.financialInstitutionNo)
          formData.append('documentFor',"MGA");
              formData.append('documentType',this.documentType)
              formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
              formData.append('mgaId',this.mgaId)
          if(this.fileIdvoid!=null || this.voidchequeId!=null){
            formData.append('fileId', this.fileIdvoid);
             formData.append('documentId', this.voidchequeId);
           
          }
            // this.fileData=formData
    
          this.uploadImagesvoidMGA(formData, k)
        }
    
      }
    }
    else{
      const formData = new FormData();
      // formData.append('file', this.productPhotofile1);
      var data = this.leadId
      formData.append('leadId', data);
      formData.append('documentFor',"MGA");
      formData.append('documentType',this.documentType)
      formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
      formData.append('mgaId',this.mgaId)
      formData.append('accountNumber', this.accountNo);
    formData.append('confirmaccountNo', this.confirmaccountNo);
    formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
    formData.append('transitNumber', this.transitNo);
    formData.append('bankNumber',this.financialInstitutionNo)
      //  this.fileData=formData
      if(this.fileIdvoid!=null || this.voidchequeId!=null){
        formData.append('fileId', this.fileIdvoid);
        formData.append('documentId', this.voidchequeId);
       
      }
    
    
      this.uploadImagesvoidMGA(formData, k)
    }
    }
    finalDocs1: any;
    mgaIndex: any=0;
    agencyIndex: any=0;
    async uploadImagesvoidMGA(formData: FormData, k) {
      
      this.loading = true;
      if(this.fileIdvoid==null || this.voidchequeId==null){
      this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.isOverWriteEO=false
        this.finalDocs1 = data.data;
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadVoidChequePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
        this.getMGADocuments(this.mgaId,this.mgaIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
      
      }, err => {
      
      });
      }else{
      this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.isOverWriteEO=false
        this.finalDocs1 = data.data;
        this.loading = false;
        this.fileIdvoid=null;
        this.voidchequeId=null;
        Swal.fire('', data.message, 'success');
        this.uploadVoidChequePopup= false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
        this.getMGADocuments(this.mgaId,this.mgaIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
      
      }, err => {
      
      });
      }
      }
      openTabs21(index){
        //debugger
        this.reset21();
        this.reset2();
        this.reset22();
        this.tabs21[index].active21 = 'active21';
        this.tabs21[index].tabcontent21 = 'tabcontent21';
          this.showLicTypeonPopup=this.MgaLicType;
      }
      tabs21 = [
        { active21: '', tabcontent21: 'hide' }, // First tab is active by default
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
        { active21: '', tabcontent21: 'hide' },
      ];
      reset21() {
        for (let i = 0; i < this.tabs21.length; i++) {
          this.tabs21[i].active21 = '';  // Deactivate all tabs
          this.tabs21[i].tabcontent21 = 'hide';  // Hide all tab content
        }
      }
      tabs2 = [
        { active2: 'active2', tabcontent2: 'tabcontent2' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        
        ];
      reset2() {
        for (let i = 0; this.tabs2.length > i; i++) {
        this.tabs2[i].active2 = '';
        this.tabs2[i].tabcontent2 = 'hide';
        }
        }
        reset22() {
          for (let i = 0; i < this.tabs22.length; i++) {
            this.tabs22[i].active22 = '';  // Deactivate all tabs
            this.tabs22[i].tabcontent22 = 'hide';  // Hide all tab content
          }
        }
        tabs22 = [
          { active22: '', tabcontent22: 'hide' }, // First tab is active by default
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
          { active22: '', tabcontent22: 'hide' },
        ];
        async uploadImages1(formData: FormData, k) {
          this.loading = true;
          
          if(this.showCompanyDelete==false){
          if(this.fileIdvoid==null || this.voidchequeId==null){
          this.user.submitFormService(this.config.uploadVoidChequebroker, formData).subscribe((data: any) => {
            this.isBankingInfoAvailable=true
            localStorage.setItem('isBankingInfoAvailable', JSON.stringify(true));
            this.finalDocs1 = data.data;
            this.loading = false;
            this.uploadVoidChequePopup = !this.uploadVoidChequePopup;
            Swal.fire('', data.message, 'success');
            // this.getDocument();
            this.getLeadDoc();
            this.getLicensRequest();
            this.getEORequest();
        this.getVoidChequeRequest();  
            this.openTabs(1)
            this.showDocumentName1 = data.data.documentName;
            this.fileenoName1 = ""
            this.uploadvoidchequeArray.splice(k, 1);
            this.uploadvoidchequeArray.push(data.data)
      
          }, err => {
      
          });
        }
        else{
          this.user.submitFormService(this.config.OverWriteVoidCheque, formData).subscribe((data: any) => {
            this.isBankingInfoAvailable=true
            localStorage.setItem('isBankingInfoAvailable', JSON.stringify(true));
            this.fileIdvoid=null; 
            this.voidchequeId=null;
            this.finalDocs1 = data.data;
            this.loading = false;
            this.BankInfo = false;
            this.uploadVoidChequePopup = false;
            Swal.fire('', data.message, 'success');
            // this.getDocument();
            this.getLeadDoc();
            this.openTabs(1)
            this.getLicensRequest();
            this.getEORequest();
        this.getVoidChequeRequest();  
            this.showDocumentName1 = data.data.documentName;
            this.fileenoName1 = ""
            this.uploadvoidchequeArray.splice(k, 1);
            this.uploadvoidchequeArray.push(data.data)
      
          }, err => {
      
          });
        }
          }else{
            if(this.fileIdvoid==null || this.voidchequeId==null){
              this.user.submitFormService(this.config.uploadVoidAgency, formData).subscribe((data: any) => {
                this.isBankingInfoAvailable=true
                localStorage.setItem('isBankingInfoAvailable', JSON.stringify(true));
                this.finalDocs1 = data.data;
                this.loading = false;
                this.uploadVoidChequePopup = !this.uploadVoidChequePopup;
                Swal.fire('', data.message, 'success');
                // this.getDocument();
                this.openTabs22(this.agencyIndex);
            this.callAgencyDoc(this.agencyId,this.agencyIndex)
                this.getLicensRequest();
                this.getEORequest();
        this.getVoidChequeRequest();  
                this.showDocumentName1 = data.data.documentName;
                this.fileenoName1 = ""
                this.uploadvoidchequeArray.splice(k, 1);
                this.uploadvoidchequeArray.push(data.data)
          
              }, err => {
          
              });
            }
            else{
              this.user.submitFormService(this.config.updateVoidAgency, formData).subscribe((data: any) => {
                this.isBankingInfoAvailable=true
                localStorage.setItem('isBankingInfoAvailable', JSON.stringify(true));
                this.fileIdvoid=null; 
                this.voidchequeId=null;
                this.finalDocs1 = data.data;
                this.loading = false;
                this.BankInfo = false;
                this.uploadVoidChequePopup = false;
                Swal.fire('', data.message, 'success');
                // this.getDocument();
                this.openTabs22(this.agencyIndex);
            this.callAgencyDoc(this.agencyId,this.agencyIndex)
                this.getLicensRequest();
                this.getEORequest();
        this.getVoidChequeRequest();  
                this.showDocumentName1 = data.data.documentName;
                this.fileenoName1 = ""
                this.uploadvoidchequeArray.splice(k, 1);
                this.uploadvoidchequeArray.push(data.data)
          
              }, err => {
          
              });
            }
          }
        }
        tabs = [
          { active: 'active', tabcontent: 'tabcontent' },
          { active: '', tabcontent: 'hide' },
          { active: '', tabcontent: 'hide' },
          { active: '', tabcontent: 'hide' },
          { active: '', tabcontent: 'hide' },
          { active: '', tabcontent: 'hide' },
          
          ];
          hidecircle:boolean=true;
          agentcbtn:boolean=true;
        openTabs(index){
          this.callMgaAPI=false
          this.reset();
          this.tabs[index].active = 'active';
          this.tabs[index].tabcontent = 'tabcontent';
          if(index==0)
          {
            
            this.hidecircle=true;
        
          }
          else
          {
            this.hidecircle=false;
        
          }
        if(index==2 || index==3)
        {
          this.agentcbtn=false;
        }
        else
        {
          this.agentcbtn=true;
        
        }
        }
        reset() {
          for (let i = 0; this.tabs.length > i; i++) {
          this.tabs[i].active = '';
          this.tabs[i].tabcontent = 'hide';
          }
          }
        openTabs22(index){
          //debugger
          this.reset21();
          this.reset2();
          this.reset22();
          this.tabs22[index].active22 = 'active22';
          this.tabs22[index].tabcontent22 = 'tabcontent22';
         
            this.showLicTypeonPopup=this.corporateLicType;
          
        
        }
        callAgencyDoc(id,index){
          this.agencyId=id
          this.agencyIndex=index
          this.getLicensRequest();
          this.getEORequest();
        this.getVoidChequeRequest();  
          this.getLeadSDocumentAgency(this.agencyId,this.leadId);
          this.openTabs22(this.agencyIndex);
          this.showCompanyDelete=true;
          this.callMgaAPI=false
        }
        getLicences1=[];
        maskaccountNo: any;
        eyeIconShowAccountNumber: boolean =false;
        type: any;
        uploadlicenseArray: Array<any> = [];
        showCompany: boolean=false;
        getLeadSDocumentAgency(agencyId,leadId){
          // debugger
          this.user.getAgencydocuments(agencyId,leadId).pipe()
        .subscribe(
            data => {
              this.getDocuments=[];
              this.getLicences=[];
              this.getVoidCheck=[];
              this.getLicences1=[];
              if(data.data.accountDetails.length!=0){
                this.transitNo = data.data.accountDetails[0]?.transitNumber;
                this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
                this.accountNo = data.data.accountDetails[0]?.accountNumber;
                this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
                this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
                this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
              }
              else{
                this.transitNo =null;
                this.financialInstitutionNo=null;
                this.accountNo=null;
                this.confirmaccountNo =null;
                this.maskaccountNo =null;
                this.eyeIconShowAccountNumber =null;
              }
              if(data.data.documents != null){
                this.getDocuments.push(data.data.documents);
              }
              if(data.data.licences != null){
                this.getLicences = data.data.licences;
              }
              if (this.type == 'Travel Agent') {
                this.getLicences = this.getLicences.filter(licence => {
                    // Check the provinceCode for each licence and remove if it's not 'NS'
                    return licence.provinces.provinceCode === 'NS';
                });
            }
              if (data.data.licences.length != 0) {
               
                for (var i = 0; i < data.data.licences.length; i++) {
                  var obj = {}
                  //this.uploadlicenseArray.push(data.data.licences[i]);
                  try{obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();}catch{}
                  obj["createdAt"] = data.data.licences[i].createdAt;
                  obj["createdBy"] = data.data.licences[i].createdBy;
                  obj["description"] = data.data.licences[i].description;
                  obj["expiryDate"] = data.data.licences[i].expiryDate;
                  obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
                  obj["fileId"] = data.data.licences[i].fileId;
                  obj["fileUrl"] = data.data.licences[i].fileUrl;
                  obj["id"] = data.data.licences[i].id;
                  obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
                  obj["licencesProvince"] = data.data.licences[i].licencesProvince;
                  obj["licencesType"] = data.data.licences[i].licencesType;
                  obj["licenseName"] = data.data.licences[i].licenseName;
                  obj["licensesNumber"] = data.data.licences[i].licensesNumber;
                  obj["status"] = data.data.licences[i].status;
                  obj["type"] = data.data.licences[i].type;
                  obj["updatedAt"] = data.data.licences[i].updatedAt;
                  obj["provinceName"] = data.data.licences[i].provinces.provinceName;
                  obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
                  obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
                  obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
                 
                  this.uploadlicenseArray.push(obj)
                }
                
               
              }
              this.showCompany=true;
              
              // if(data.data.accountDetails != null){
              //   this.getVoidCheck = data.data.accountDetails;
              // }
               if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidCheck.push(voidChequeaccountDetails);
          });
        }
            },error=>{
                },()=>{});
        }
        onBankInfoSelected(data){
    
          var checkFlag = data.target.checked;
          if(checkFlag == true){
            this.allowUser = true;
            this.bankInfoErrmsg = false;
            this.bankinfoChecked=true;
          }
          else{
            this.bankInfoErrmsg = true;
            this.allowUser = false;
            this.bankinfoChecked=false;
          }
        }
        confirmAccountNumberMatch: boolean=false;
  accountConfirmFlag:boolean=false;
  checkConfirmAccountNumber(){
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}
    
    if(this.accountNo && this.confirmaccountNo){
      if(this.accountNo==this.confirmaccountNo){
        this.confirmAccountNumberMatch = false;
        this.accountConfirmFlag = false;
      }else{
        this.confirmAccountNumberMatch = true;
        this.accountConfirmFlag = false;
      }
    }
    
  }
  checkAccountNumber(){
    try{this.accountNo=this.accountNo.trim()}catch{}
    if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
    
    if(this.accountNo && this.confirmaccountNo){
      if(this.accountNo==this.confirmaccountNo){
        this.confirmAccountNumberMatch = false;
        this.accountConfirmFlag = false;
        // this.allowUser=true
      }else{
        this.confirmAccountNumberMatch = true;
        this.accountConfirmFlag = false;
        // this.allowUser=false
      }
    }
    
  }
  confirmaccountNoErrMsgred(){
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}}
  transitNoErrMsgred(){
    try{this.transitNo=this.transitNo.trim()}catch{}
    if(!this.transitNo){this.transitNoErrMsg = true} else{this.transitNoErrMsg = false}}
  financialInstitutionNoErrMsgred(){
    try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
    if(!this.financialInstitutionNo){this.financialInstitutionNoErrMsg = true} else{this.financialInstitutionNoErrMsg = false}}
  accountNoErrMsgred(){
    //
    try{this.accountNo=this.accountNo.trim()}catch{}
    if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
  }
  voidfile:File=null;
  fileExtensionVC: any;
  fileExtensionErrorVC: boolean = false;
  fileExtensionMessageVC: any;
  FileSelect1(event, i) {
    
    if (event.target.files.length > 0) {
    //
    this.voidfile = event.target.files[0];
    if(this.voidfile.size>4194304){
      this.voidSizeCheck=true;
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.showemailErrorMsg1 = false;
      this.voidSizeCheck=false;
    }


    
      this.FileDataList1 = event.target.files;
      this.fileenoName1 = this.FileDataList1[0].name;

      try{this.fileExtensionVC = this.fileenoName1.split('.').pop();}catch{}
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionVC)) {
        this.fileExtensionErrorVC = false;
        this.fileExtensionMessageVC = ""

        this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
        this.fileenoName1 = this.FileDataList1[0].name;
      } else {
        this.fileExtensionMessageVC = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorVC = true;
        this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
        this.fileenoName1 = this.fileExtensionMessageVC

      }

    } else {
      // this.uploadvoidchequeArray[i].showemailErrorMsg1 = false;
      // this.fileenoName1 = ""
      this.uploadvoidchequeArray[i].fileeno1=this.fileenoName1
    }
  }
  closeBankInfoPopup1(){
    this.fileenoName1 = null;
    this.transitNoErrMsg = false;
    this.financialInstitutionNoErrMsg = false;
    this.accountNoErrMsg = false;
    this.confirmaccountNoErrMsg = false;
    this.confirmAccountNumberMatch = false;
    this.bankinfoChecked = false;
  }
  openbankingInfoPop(){
    //debugger
   this.uploadVoidChequePopup = true;
   this.addFieldValuecheque();
  }
  newAttributenext: any = {};
  addFieldValuecheque() {
    this.uploadvoidchequeArray=[]
    this.uploadvoidchequeArray.push(this.newAttributenext)
    this.newAttributenext = {};
    //this.uploaddocs2();
  }
  prepoulateBankInfo(){
    this.uploadvoidchequeArray[0].fileeno1=false
    this.allowUser=false
      this.accountNoErrMsg = false;
      this.financialInstitutionNoErrMsg = false;
      this.transitNoErrMsg = false;
      this.confirmaccountNoErrMsg = false;
      this.transitNo = this.transitNm;
      this.financialInstitutionNo = this.financialInstNumber;
      this.accountNo = this.accNm;
      this.confirmaccountNo = this.accNm;
      this.confirmAccountNumberMatch = false;
      this.bankinfoChecked = false;
  }
  confirmSINNumberMatch: boolean=false;
  SINConfirmFlag:boolean=false;
  checkConfirmSINNumber(){
    //debugger
    try{this.confirmsinNo=this.confirmsinNo.trim()}catch{}
    if(!this.confirmsinNo){this.confirmsinNoErrMsg = true} else{this.confirmsinNoErrMsg = false}
    
    if(this.sinNo && this.confirmsinNo){
      if(this.sinNo==this.confirmsinNo){
        this.confirmSINNumberMatch = false;
        this.confirmsinNoErrMsg = false;
        this.SINConfirmFlag = false;
      }else{
        this.confirmSINNumberMatch = true;
        this.confirmsinNoErrMsg = true;
        this.SINConfirmFlag = false;
      }
    }
    
  }
  checkSINNumber(){
    try{this.sinNo=this.sinNo.trim()}catch{}
    if(!this.sinNo){this.sinNoErrMsg = true} else{this.sinNoErrMsg = false}
    
    if(this.sinNo && this.confirmsinNo){
      if(this.sinNo==this.confirmsinNo){
        this.confirmAccountNumberMatch = false;
        this.confirmsinNoErrMsg = false;
        this.accountConfirmFlag = false;
        // this.allowUser=true
      }else{
        this.confirmAccountNumberMatch = true;
        this.confirmsinNoErrMsg = true;
        this.accountConfirmFlag = false;
        // this.allowUser=false
      }
    }
    
  }
  prepoulateSINInfo(){
    this.sinNo=null
    this.confirmsinNo=null
    this.confirmSINNumberMatch = false;
    this.confirmsinNoErrMsg = false;
    this.accountConfirmFlag = false;
    this.sinNoErrMsg= false;
    this.SINConfirmFlag= false;
  }
  proceed() {
    // debugger
    var flag = true
    var errormsg = [];
    this.msg =null
this.msgfinal=null
    if (!this.sinNo || this.sinNo == "") { flag = false; errormsg.push("'SIN'")}
    if (!this.confirmsinNo || this.confirmsinNo == "") { flag = false; errormsg.push("'Confirm SIN'")}
    if(this.sinNo && this.confirmsinNo){
      if(this.confirmAccountNumberMatch || this.confirmsinNoErrMsg){flag = false; return}
    }
    if (this.personalinfo.languages?.length>0) {
      for (let i = 0; i < this.personalinfo.languages.length; i++) {
        this.languages.push(this.personalinfo.languages[i].id)
      }
    }
    
    if (this.personalinfo.tags?.length>0) {
      for (let i = 0; i < this.personalinfo.tags.length; i++) {
        this.tags.push(this.personalinfo.tags[i].id)
      }
    }
    if (this.PLicensedArray != null) {
      this.allProvicesList=[]
if (this.PLicensedArray.length > 0) {
  for (let i = 0; i < this.PLicensedArray.length; i++) {
    const matched = this.personalinfo.leadProvinces.filter(itm => 
      itm.provinces &&
      (itm.provinces.provinceName + '-' + itm.provinces.provinceCode === this.PLicensedArray[i].itemName)
    );

    // Only proceed if there's a match
    if (matched.length > 0) {
      const obj = {
        id: this.PLicensedArray[i].id,
        provinces: this.PLicensedArray[i].id
      };
      this.allProvicesList.push(obj);
    }
  }
}
       //console.log(JSON.stringify(this.allProvicesList))
    }
    var obj = {};
          obj["email"] = this.personalinfo.emailAddress[0].email;
          obj["id"] = this.personalinfo.emailAddress[0].id;
          obj["isInvalid"] = this.personalinfo.emailAddress[0].isInvalid;
          obj["isOptedOut"] = this.personalinfo.emailAddress[0].isOptedOut;
          obj["isPrimary"] = this.personalinfo.emailAddress[0].isPrimary;
          this.emailAddress.push(obj);
        
    if (flag == true && this.hideLastRequestedDateSIN==false) {
      this.user.addMember(this.firstName,
        this.personalinfo.middlename,
          this.lastName,
          //this.personalinfo.selectedLanguage,
          this.languages,
          this.personalinfo.allProvicesList,
          // this.tags,
          this.personalinfo.primaryAddressCity,
          this.personalinfo.primaryAddressCountry,
          this.personalinfo.primaryAddressPostalCode,
          this.personalinfo.primaryAddressProvince,
          this.personalinfo.primaryCompleteAddress,
          this.personalinfo.workPhone,
          this.personalinfo.workPhoneExtension,
          this.personalinfo.alternativeAddressCity,
          this.personalinfo.alternativeAddressCountry,
          this.personalinfo.alternativeAddressPostalCode,
          this.personalinfo.alternativeAddressProvince,
          this.personalinfo.alternativeCompeteAddress,
          this.personalinfo.ciprnumber,
          this.emailAddress,
          this.personalinfo.mobileNumber,
          this.personalinfo.positionTitle,
          this.personalinfo.leadId,
          this.personalinfo.salutation,
          this.personalinfo.agencyMgaId,
          this.personalinfo.assignedTo.id,
          this.leadStatus,
          this.leadType,
          this.personalinfo.website,
          this.personalinfo.isCompanySignup,
          this.personalinfo.companyName,
          this.personalinfo.myTravelLinkRequest,this.personalinfo.agencyId,this.sinNo,this.wfgCode
        )
          .pipe()
          .subscribe(
            data => {            
              if (data.success == true) {
                Swal.fire('', "SIN updated Successfully", 'success')
                this.SINPopup=false
                this.isSINInfoAvailable=true
                localStorage.setItem('isSINInfoAvailable', JSON.stringify(false));
                 } else {
                              Swal.fire('', data.data, 'error')
                
                            }
                             }, error => {
                                      
                                      }, () => { });
                                      }
                                      else if(flag == true && this.hideLastRequestedDateSIN==true){                                        
this.addSin()
                                      }
                                          else {
                                            this.msg = errormsg.toString();
                                      this.msgfinal = this.msg.replace(/,/g, '<br />');  // Use regex to replace all commas
                                      Swal.fire({
                                        title: "",
                                        html: "Please complete the following mandatory field(s):<br>" + this.msgfinal,  // Use 'html' instead of plain text
                                        icon: 'warning'
                                      });
                                          }
}
requestLicensarrayEO=[]
getEORequest(){
    this.user.getLicenseRequestCall(this.leadId,'EO').pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.requestLicensarrayEO=[]
        this.requestLicensarrayEO=data.data
        }else{
        this.requestLicensarrayEO=[]
        }
      },error=>{
          },()=>{});
  }
  requestLicensarrayVoidCheque=[]
getVoidChequeRequest(){
    this.user.getLicenseRequestCall(this.leadId,'VOID_CHEQUE').pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.requestLicensarrayVoidCheque=[]
        this.requestLicensarrayVoidCheque=data.data
        }else{
        this.requestLicensarrayVoidCheque=[]
        }
      },error=>{
          },()=>{});
  }
  OverwriteEODocRequested(data) {
      this.requestedData=data
      this.isDocumentRequested = true
      if (data.type == 'LINCENCES') {
        this.uploadnewLicensePopup = true;
      }
      if (data.type == 'EO') {
        this.expiryDate = "";
      this.effectiveDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
        this.uploadEOPopup = true
      }
      if (data.type == 'VOID_CHEQUE') {
        // this.editBankInfo()
        this.transitNo =null;
        this.financialInstitutionNo=null;
        this.accountNo=null;
        this.confirmaccountNo =null;
        this.maskaccountNo =null;
        this.eyeIconShowAccountNumber =null;
        this.bankinfoChecked = false;
        this.fileIdvoid=null; 
        this.voidchequeId=null;
        this.finalDocs1 = data.data;
        this.loading = false;
        this.BankInfo = false;
this.fileenoName1 = ""
        this.openbankingInfoPop()
      }
    }
    RequestedDocumentAddUpdateEO(type) {
      let docFor = '';
  if (!this.showCompanyDelete && !this.callMgaAPI) {
    docFor = 'LEAD';
  } else if (this.showCompanyDelete && !this.callMgaAPI) {
    docFor = 'Agency';
  } else if (!this.showCompanyDelete && this.callMgaAPI) {
    docFor = 'MGA';
  }
      const formData = new FormData();
      formData.append('file', this.FileDataList[0]);
      formData.append('expiryDate', this.expiryDate);
      formData.append('effectiveDate', this.effectiveDate);
      formData.append('leadId', this.leadId);
      // formData.append('agencyId',this.agencyId)
      formData.append('DocNumber',this.policyNumber)
      // formData.append('accountNumber',this.agencyId)
      // formData.append('bankNumber',this.policyNumber)
      formData.append('docName',this.fileenoName)
      formData.append('documentFor',docFor)
      
      formData.append('documentType',type)
      formData.append('isOverwrite','false')   
  if(this.showCompanyDelete==true){
            formData.append('agencyId ', this.agencyId);
          }
  if(this.callMgaAPI==true){
  formData.append('mgaId',this.mgaId)
          }
      if( this.requestedData.documentId!=undefined || this.requestedData.documentId!=null){
        formData.append('documentId', this.requestedData.documentId)
        formData.append('isOverwrite','true')   
      }
      formData.append('requestedId', this.requestedData.id);
      this.uploadRequestedDoc(formData)
    }
    RequestedDocumentAddUpdateLic(expiryDateLic1,filelicens,licenseNumber,licencesType,province,oricDocumentId,effectiveDateLic1,type) {
      let docFor = '';
      if (!this.showCompanyDelete && !this.callMgaAPI) {
        docFor = 'LEAD';
      } else if (this.showCompanyDelete && !this.callMgaAPI) {
        docFor = 'Agency';
      } else if (!this.showCompanyDelete && this.callMgaAPI) {
        docFor = 'MGA';
      }
      const formData = new FormData();
      formData.append('file',this.FileDataListLic[0]);
      formData.append('expiryDate', expiryDateLic1);
        formData.append('effectiveDate', effectiveDateLic1);
        formData.append('leadId', this.leadId);
        formData.append('DocNumber', licenseNumber);
        formData.append('docName', this.fileenoNameLic);
        formData.append('licencesType', licencesType);
        formData.append('province', province);     
 
  if(this.licenceId!=null){
    if(this.isOverWriteEO==true){
      formData.append('documentId',this.licenceId)
      }
        
      }
      formData.append('documentFor',docFor)
      
      formData.append('documentType',type)
      formData.append('isOverwrite','false')    
  if(this.showCompanyDelete==true){
            formData.append('agencyId ', this.agencyId);
          }
  if(this.callMgaAPI==true){
  formData.append('mgaId',this.mgaId)
          }
  
  if(this.requestedData.id !=null ){
  formData.append('requestedId', this.requestedData.id);
  }
      // this.fileData=formData
  
      this.uploadRequestedDoc(formData)
    }
    RequestedDocumentAddUpdateVoid(uploadlic, k,type) {
      let docFor = '';
      if (!this.showCompanyDelete && !this.callMgaAPI) {
        docFor = 'LEAD';
      } else if (this.showCompanyDelete && !this.callMgaAPI) {
        docFor = 'Agency';
      } else if (!this.showCompanyDelete && this.callMgaAPI) {
        docFor = 'MGA';
      }
      const formData = new FormData();
      formData.append('file', this.FileDataList1[0]);
      formData.append('leadId', this.leadId);
      formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
      formData.append('documentFor',docFor);
          formData.append('documentType',type)
          formData.append('isOverwrite','false');
  if(this.showCompanyDelete==true){
              formData.append('agencyId ', this.agencyId);
            }
  if(this.callMgaAPI==true){
    formData.append('mgaId',this.mgaId)
            }
          
      if(this.fileIdvoid!=null ){
        formData.append('fileId', this.fileIdvoid);
      }
      if(this.requestedData.documentId!=null){        
          formData.append('documentId', this.requestedData.documentId);
          formData.append('isOverwrite','true');
      }
      if(this.requestedData.id!=null){     
      formData.append('requestedId', this.requestedData.id);
      }
      this.uploadRequestedDoc(formData)
    }
  
    uploadRequestedDoc(formData){
      this.loading = true;
      this.user.submitFormService(this.config.v2GetRequestedDocumentAddUpdate, formData).subscribe((data: any) => {
        this.loading = false;
        this.isDocumentRequested = false
        this.uploadEOPopup = false
        this.uploadVoidChequePopup = false
        this.uploadnewLicensePopup = false;
        this.getLicensRequest();
        this.getEORequest();
        this.getVoidChequeRequest();   
        Swal.fire({
          text: data.message,  
          icon: 'success',      
          confirmButtonColor: '#CC4037',       
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
        // this.ProceedPromt();      
      }
    }) 
        
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
    
      });  
    }
    requestedSINHistory(leadId){
      this.requestSINHistory=[]
      this.user.getLicenseRequestCall(leadId,'SIN').pipe()
      .subscribe(
          data => {
             
            if(data.data!="Request Not Found."){
              this.hideLastRequestedDateSIN=true
              // sessionStorage.setItem('sinRequested', JSON.stringify(data.data))
              this.requestSINHistory=data.data;
            //   for(let i=0;i<this.requestHistory?.length;i++){
            //   if(this.requestHistory[i].isRequestCompleted==false){
            //     this.hideLastRequestedDate=true;
            //   }
            // }
              this.lastRequestedDateSIN=this.requestSINHistory[0]?.createdAt;
              this.lastRequestedDateSINBy=this.requestSINHistory[0]?.requestedBy;
            }
            if(data.data=="Request Not Found."){
              this.hideLastRequestedDateSIN=false;
            }
          },error=>{
            this.hideLastRequestedDateSIN=false;
              },()=>{});
      }
      addSin(){
        this.user.addUpdateSIN(this.personalinfo.leadId,this.requestSINHistory[0].id,this.sinNo).pipe()
      .subscribe(
          data => {
            this.SINPopup =false
            this.sinNo=null
            this.confirmsinNo=null
            this.confirmSINNumberMatch = false;
            this.confirmsinNoErrMsg = false;
            this.accountConfirmFlag = false;
            this.sinNoErrMsg= false;
            this.SINConfirmFlag= false;
              this.hideLastRequestedDateSIN=false            
            
          },error=>{
              },()=>{});
      }

      annualConfirmationPopup() {
        debugger;
        this.user.annualConfirmationPopup(this.leadId).pipe()
          .subscribe(
            data => {
              debugger;
              this.checkStatusAnnualConfirmation = data.status;
      
              // Use '===' to compare, not '=' (which is assignment)
              if (this.checkStatusAnnualConfirmation === true) {
                this.ConfirmationPopupAnnual = true;
              } else {
                this.ConfirmationPopupAnnual = false;
              }
            },
            error => {
              if (error.status === 400 || error.status === 417) {
                this.error = error.error.data;
              } else {
                this.error = "Something went wrong. Please check username and password.";
              }
            },
            () => { /* Completion callback (optional) */ }
          );
      }
      // rememberMe(data) {
      //   this.rememberMeChecked = data.target.checked;
      //   if (this.rememberMeChecked == true) {
      //   }
      //   else {
      //     sessionStorage.clear();
    
      //   }
      // }
      rememberMe(event: any, checkboxName: string): void {
        this.checkboxes[checkboxName] = event.target.checked;
      }
      checkboxes = {
        cb1: false,
        cb2: false,
        cb3: false,
        cb4: false
      };
      
      get allChecked(): boolean {
        return Object.values(this.checkboxes).every(val => val === true);
      }
      annualConfirmationPopupConfirmAction(){
        this.relatedToName = 'Lead'
        this.action = 'CONFIRM'
        this.optOutDays= null;
        this.relatedToId = +this.leadId;
        this.user.annualConfirmationPopupAction(this.relatedToId,this.relatedToName,this.action,this.optOutDays,this.name).pipe()
      .subscribe(
          data => {
            Swal.fire({
              text: data.message,  
              icon: 'success',      
              confirmButtonColor: '#CC4037',       
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {    
          }
        })      
        this.ConfirmationPopupAnnual = false;   
          },error=>{
              },()=>{});
      }
      annualConfirmationPopupCancelAction(){
        this.relatedToName = 'Lead'
        this.action = 'CANCEL'
        this.optOutDays= null;
        this.relatedToId = +this.leadId;
        sessionStorage.setItem('checkUserIsCancelledannualConfirmationPopup', 'true');
        this.user.annualConfirmationPopupAction(this.relatedToId,this.relatedToName,this.action,this.optOutDays,this.name).pipe()
      .subscribe(
          data => {
            Swal.fire({
              text: data.message,  
              icon: 'success',      
              confirmButtonColor: '#CC4037',       
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {    
          }
        })      
        this.ConfirmationPopupAnnual = false;   
        },error=>{
        },()=>{});
      }
      
}
